/* eslint-disable camelcase */
import React, {useEffect, useState} from 'react';
import HelperUtils, {
  GetDisableCheckBox,
  rowStyles
} from '@shared/utils/HelperUtils';
import {useSnackbar} from 'notistack';
import {useModuleContext} from '@context/ModuleContext';
import {Tooltip, Typography, useTheme} from '@mui/material';
import {
  useGridApiRef,
  useKeepGroupedColumnsHidden,
  GridFilterModel,
  GridRowParams,
  GridRowSelectionModel,
  GridFilterInputValue,
  GridFilterItem,
  GridToolbarContainer,
  GridToolbarQuickFilter
} from '@mui/x-data-grid-premium';
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  List,
  ListItemButton,
  TablePagination
} from '@mui/material';
import {
  getGridDateOperators,
  GridLogicOperator,
  GridRowId,
  GridSortModel
} from '@mui/x-data-grid';
import {ClearIcon, DatePicker, LocalizationProvider} from '@mui/x-date-pickers';
import {
  getAllUsers,
  getPageData,
  getSearchResultsData,
  getUserAuditsData,
  getUserAccessAuditsData,
  createAuditLog,
  getReportsFileExportData,
  getAllUsersSettings
} from '@shared/services/service-handlers/PrivateService';

import {
  Autocomplete,
  Box,
  Chip,
  MenuItem,
  Select,
  TextField
} from '@mui/material';
import {getErrorMessage} from '@shared/utils/ErrorUtils';
import SnackBarConfig from '@components/snackbar/SnackbarConfig';
import AuthUtils from 'src/utils/AuthUtils';
import {useSelectedCheckBoxContext} from '@context/SelectedCheckBoxContext';
import EncryptUtils from 'src/utils/EncryptUtils';
import FormConstants from '@shared/constants/FormConstants';
import {environment} from '@shared/config/environment';
import {APP} from 'src/styles/variables';
import {
  BASE_DATA_GRID_ROW,
  BASE_RECORD_ID,
  CHILD_TAB_NAME,
  INVOICE_NUMBER,
  LOCAL_SEARCH,
  PARAMS_KEY,
  SEARCH_CONTEXT
} from 'src/routes/BaseRoute';
import {useLocation, useNavigate, useParams} from 'react-router-dom';
import {useAppContext} from '@context/AppContext';
import {StripedDataGrid} from './DataGridComponentStyles';
import {CircularProgressDiv} from '@modules/public/main/login/LoginStyles';
import {PulseLoader} from 'react-spinners';
import moment from 'moment';
import dayjs from 'dayjs';
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';
import {generateSubModuleIdentifier} from 'src/utils/helperUtils';
import {useBannerDetails} from '@context/BannerContext';
import {LoadingButton} from '@mui/lab';
import HighlighterWrapper from '@components/highlighterWrapper/HighlighterWrapper';

interface DataGridProps {
  setRefreshFilter?: any;
  refreshFilter?: any;
  rows: any;
  columns: any;
  className?: string;
  rowHeight?: number;
  // eslint-disable-next-line react/boolean-prop-naming
  autoHeight?: boolean;
  rowsPerPageOptions?: Array<any>;
  // eslint-disable-next-line react/boolean-prop-naming
  disableColumnMenu?: boolean;
  // eslint-disable-next-line react/boolean-prop-naming
  disableColumnSelector?: boolean;
  // eslint-disable-next-line react/boolean-prop-naming
  disableRowSelectionOnClick?: boolean;
  optionalClassName?: string;
  evenRowClassName?: string;
  page?: number;
  pageSize?: number;
  oddRowClassName?: string;
  onRowClick?: any;
  slots?: any;
  slotProps?: any;
  onPageChange?: (data: any) => void;
  paginationMode?: any;
  sortingMode?: any;
  sortingOrder?: any;
  rowCount?: any;
  pagination?: any;
  onPageSizeChange?: (data: any) => void;
  getDetailPanelContent?: any;
  getDetailPanelHeight?: any;
  onSortModelChange?: any;
  module?: any;
  sub_module?: any;
  sectionUIData?: any;
  rowThreshold?: any;
  getRowId?: any;
  style?: any;
  hideFooter?: any;
  selectedRowDetails?: any;
  initialState?: any;
  recordId?: string;
  experimentalFeatures?: any;
  columnGroupingModel?: any;
  checkboxSelection?: any;
  handleOnSelectionModelChange?: any;
  selectedCheckboxColumns?: any;
  isFromModules?: boolean;
  rowsCount?: number;
  setRowsCountData?: (data: number) => void;
  rowsCountData?: any;
  setRowsPAData?: (data: any) => void;
  searchFormFieldsData?: any;
  // eslint-disable-next-line react/boolean-prop-naming
  handleDisableCheckBox?: boolean;
  legacyApp?: string;
  BenefitsPayload?: any;
  isReportsButtonLoader?: boolean;
  onCellClick?: any;
  isEnabled?: any;
  ExpandableRowInFlowSheets?: any;
  groupingColDef?: any;
  ParentLegacyValue?: string;
  growthChartType?: string;
  columnVisibilityModel?: any;
  expandedRowIds?: any;
  setExpandedRowIds?: (ids: GridRowId[]) => void;
  onColumnVisibilityModelChange?: (parmas: any) => void;
  gridHeight?: string | undefined;
  // eslint-disable-next-line react/boolean-prop-naming
  loading?: boolean;
  procedure_type?: string;
  accession_number?: string;
  specimen_number?: any;
  specimen_number_id?: any;
  procedure_id?: any;
  demographic_id?: any;
  sx?: any;
  onPaginationModelChange?: any;
  limited?: number;
  offseted?: number;
  // eslint-disable-next-line react/boolean-prop-naming
  openning?: boolean;
  setopening?: React.Dispatch<any>;
  // eslint-disable-next-line react/boolean-prop-naming
  deleteDocument?: boolean;
  onDataReceiveForGridSearch?: any;
  setDeleteDocument?: React.Dispatch<any>;
  // eslint-disable-next-line react/boolean-prop-naming
  displayToolbar?: boolean;
  minHeight?: string | number;
  columnHeaderHeight?: number;
  // eslint-disable-next-line react/boolean-prop-naming
  displayHorizontalScroll?: boolean;
  onGridFiltersChange?: any;
  isRowSelectable?: any;
  checkboxColor?: any;
  processRowUpdate?: any;
  pinnedRowsData?: any;
  setSyncUsers?: (value: boolean) => void;
  usersync?: boolean;
  tableRefresh?: boolean;
  setTableRefresh?: (value: boolean) => void;
  TransfusionID?: string;
}

const FILTER_OPERATORS_WITHOUT_VALUE = ['isEmpty', 'isNotEmpty'];

const sanitizeNumericFilterValue = (value: any): string | undefined => {
  if (value === undefined || value === null) {
    return undefined;
  }

  const normalizedValue = value.toString().replace(/[^\d.-]/g, '').trim();

  if (
    normalizedValue === '' ||
    normalizedValue === '-' ||
    normalizedValue === '.' ||
    normalizedValue === '-.'
  ) {
    return undefined;
  }

  return normalizedValue;
};

const sanitizeGridFilterModel = (
  filterModel: GridFilterModel,
  columns: any[] = []
): GridFilterModel => {
  const timestamp = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const items =
    filterModel?.items
      ?.map(item => {
        if (!item?.field || !item?.operator) {
          return null;
        }

        const typeEntry = columns.find((col: any) => col.field === item.field);
        const columnType = typeEntry?.column_type || null;
        const currencyFormatter = typeEntry?.currnecyformatter;
        const isSchemaRequired = typeEntry?.isSchemaRequired;
        const schemaName = typeEntry?.schemaName;

        let normalizedValue = item.value;

        if (FILTER_OPERATORS_WITHOUT_VALUE.includes(item.operator)) {
          normalizedValue = undefined;
        } else if (Array.isArray(normalizedValue)) {
          normalizedValue = normalizedValue
            .map(value => {
              if (columnType === 'number') {
                return sanitizeNumericFilterValue(value);
              }

              return typeof value === 'string' ? value.trim() : value;
            })
            .filter(
              value => value !== undefined && value !== null && value !== ''
            );
        } else if (currencyFormatter === 'currency' || columnType === 'number') {
          normalizedValue = sanitizeNumericFilterValue(normalizedValue);
        } else if (typeof normalizedValue === 'string') {
          normalizedValue = normalizedValue.trim();
        }

        const updatedItem: any = {
          ...item,
          column_type: columnType
        };

        if (normalizedValue !== undefined) {
          updatedItem.value = normalizedValue;
        } else {
          delete updatedItem.value;
        }

        if (isSchemaRequired !== undefined) {
          updatedItem.isSchemaRequired = isSchemaRequired;
          updatedItem.schemaName = schemaName;
        }

        if (columnType === 'date' || columnType === 'date-time') {
          updatedItem.timeZone = timestamp;
        }

        return updatedItem;
      })
      .filter(Boolean) || [];

  return {
    ...filterModel,
    items,
    logicOperator: filterModel?.logicOperator || GridLogicOperator.And
  };
};

const isDateColumnType = (columnType?: string): boolean =>
  columnType === 'date' || columnType === 'date-time';

const getDateSortValue = (value: any): number => {
  if (!value) {
    return 0;
  }

  const timestamp = new Date(value).getTime();
  return Number.isNaN(timestamp) ? 0 : timestamp;
};

const formatGridDateValue = (value: any, columnType?: string): string => {
  if (!value) {
    return '';
  }

  // Never convert to the browser's local timezone — display the value exactly as
  // stored. For strings, parseZone keeps any offset present in the string. For
  // Date/number values, moment.utc avoids the local-timezone shift that plain
  // moment(value) introduces (e.g. a Date built from a "...Z" string showing 4-5
  // hours off in US timezones).
  const date =
    typeof value === 'string' ? moment.parseZone(value) : moment.utc(value);

  if (!date.isValid()) {
    return '';
  }

  return date.format(
    columnType === 'date-time' ? 'MM/DD/YYYY hh:mm:ss A' : 'MM/DD/YYYY'
  );
};

const getColumnSortValue = (value: any, columnType?: string): any => {
  if (isDateColumnType(columnType)) {
    return getDateSortValue(value);
  }

  if (typeof value === 'string') {
    return value.toLowerCase();
  }

  return value ?? '';
};

const GRID_ROW_ID_FIELD = '__bytepadGridRowId';
const STABLE_ROW_ID_FIELDS = [
  'ID',
  'id',
  'OrderID',
  'PatientID',
  'BudgetID',
  'statId',
  'CreatedDate',
  'SubscriberNumber',
  'Order',
  'PurchaseOrderID',
  'RequisitionID',
  'InvoiceID',
  'InvoiceNumber',
  'Sequence',
  'EventLevelID',
  'VoucherID',
  'PaymentID',
  'AccountID',
  'JournalID',
  'ItemID',
  'ContractID',
  'ItemVendorID'
];

const hasStableRowId = (row: any): boolean =>
  STABLE_ROW_ID_FIELDS.some(
    field => row?.[field] !== undefined && row?.[field] !== null
  );

const withGridRowIds = (data: any[] = []): any[] => {
  if (!Array.isArray(data)) {
    return data;
  }

  return data.map((row: any, index: number) => {
    if (hasStableRowId(row) || row?.[GRID_ROW_ID_FIELD]) {
      return row;
    }

    return {
      ...row,
      [GRID_ROW_ID_FIELD]: `${row?.Type || ''}-${row?.Date || ''}-${index}`
    };
  });
};

const hasSqlFieldReference = (
  sqlQuery: string | undefined,
  schemaName: string | undefined,
  fieldName: string | undefined
): boolean => {
  if (!sqlQuery || !schemaName || !fieldName) {
    return false;
  }

  return (
    sqlQuery.includes(`${schemaName}.[${fieldName}]`) ||
    sqlQuery.includes(`${schemaName}.${fieldName}`)
  );
};

const getSqlSortExpression = (
  schemaName: string | undefined,
  fieldName: string | undefined,
  castAsText = false
): string | undefined => {
  if (!schemaName || !fieldName) {
    return undefined;
  }

  // Remove existing brackets if they're already present to avoid double brackets
  const cleanFieldName = fieldName.startsWith('[') && fieldName.endsWith(']')
    ? fieldName
    : `[${fieldName}]`;

  const qualifiedField = `${schemaName}.${cleanFieldName}`;
  return castAsText
    ? `CAST(${qualifiedField} AS NVARCHAR(MAX))`
    : qualifiedField;
};

const sortRowsByModel = (
  data: any[] = [],
  sortModel: GridSortModel | undefined,
  columns: any[] = []
): any[] => {
  const rowsWithIds = withGridRowIds(data);
  const sortItem = sortModel?.[0];

  if (!sortItem?.field || !sortItem?.sort || !Array.isArray(rowsWithIds)) {
    return rowsWithIds;
  }

  const column = columns.find((col: any) => col.field === sortItem.field);
  const direction = sortItem.sort === 'asc' ? 1 : -1;

  return [...rowsWithIds].sort((rowA: any, rowB: any) => {
    const valueA = getColumnSortValue(
      rowA?.[sortItem.field],
      column?.column_type
    );
    const valueB = getColumnSortValue(
      rowB?.[sortItem.field],
      column?.column_type
    );

    if (valueA < valueB) {
      return -1 * direction;
    }

    if (valueA > valueB) {
      return 1 * direction;
    }

    return 0;
  });
};

const DataGridComponent = (props: DataGridProps): React.ReactElement => {
  const {
    appState: {applicationName}
  } = useAppContext();
  const navigate = useNavigate();
  const location = useLocation();
  const {bannerDetails} = useBannerDetails();
  const {moduleState} = useModuleContext();
  const [showDialog, setShowDialogOpen] = React.useState(false);
  const [activeAction, setActiveAction] = React.useState<string | null>(null);
  const {subModuleData, isBH, isBHReason}: any = moduleState;
  const {globalSearchConfig} = environment;
  const enableGridSearch = globalSearchConfig?.enableGridSearch;
  const theme = useTheme();
  const {enqueueSnackbar} = useSnackbar();
  const [loader, setLoader] = useState<boolean>(false);
  const childTabName = EncryptUtils.getDecryptedData(
    location?.search,
    CHILD_TAB_NAME
  );
  const query = new URLSearchParams(location.search);
  const encrypted = query.get(PARAMS_KEY);
  const decryptedParams = EncryptUtils.getDecryptedParams(encrypted);
  const {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    rows,
    columns,
    className,
    rowHeight,
    autoHeight,
    experimentalFeatures,
    // disableColumnMenu,
    disableColumnSelector,
    disableRowSelectionOnClick,
    page,
    pageSize,
    rowsPerPageOptions = [],
    onRowClick,
    slots,
    getDetailPanelHeight,
    getDetailPanelContent,
    module,
    sub_module,
    sectionUIData,
    rowThreshold,
    getRowId,
    style,
    groupingColDef,
    // hideFooter,
    columnGroupingModel,
    selectedRowDetails,
    initialState: initialStateData,
    recordId,
    paginationMode,
    sortingMode,
    sortingOrder,
    checkboxSelection,
    handleOnSelectionModelChange,
    handleDisableCheckBox = false,
    selectedCheckboxColumns = [],
    isFromModules,
    rowsCount,
    setRowsCountData,
    setRowsPAData,
    searchFormFieldsData,
    legacyApp,
    ParentLegacyValue,
    BenefitsPayload,
    isReportsButtonLoader,
    onCellClick,
    isEnabled,
    ExpandableRowInFlowSheets,
    growthChartType,
    procedure_type,
    accession_number,
    specimen_number,
    specimen_number_id,
    procedure_id,
    demographic_id,
    sx,
    onPaginationModelChange,
    limited,
    offseted,
    openning,
    setopening,
    deleteDocument,
    setDeleteDocument,
    onDataReceiveForGridSearch,
    pinnedRowsData,
    setSyncUsers,
    usersync,
    ...rest
  } = props;
  const recordIdss = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_RECORD_ID
  );

  const params = useParams();
  const invoiceNumber = EncryptUtils.getDecryptedData(
    location?.search,
    INVOICE_NUMBER
  );
  const {
    rowGrouping: rowGroupingData,
    row_grouping_model: rowGroupingModel,
    hide_columns: hideColumns,
    aggregation_grouping_model: aggregationGroupingModel,
    aggregation_position: aggregationPosition
  } = sectionUIData;
  const [excelloading, setExportExcelLoading] = React.useState(false);
  const [csvloading, setExportCSVLoading] = React.useState(false);
  const [pdfloading, setExportPDFLoading] = React.useState(false);
  const [rowsData, setRowsData]: any = React.useState([]);
  const [pinnedRows, setPinnedRows]: any = React.useState([]);
  const [gridPage, setGridPage] = React.useState(page || 0);
  const gridPageSize = React.useRef(pageSize);
  const [gridSortModel, setGridSortModel] = React.useState<GridSortModel>();
  const [rowCount, setRowCount] = React.useState(rowsCount || 0);
  const [gridOffset, setGridOffset] = React.useState<number | undefined>(
    undefined
  );
  const quickFilterInputRef = React.useRef<HTMLInputElement>(null);
  const [shouldFocusQuickFilter, setShouldFocusQuickFilter] =
    React.useState(false);
  const [updatecolumn, setupdatedcolumn] = React.useState(columns);
  const [gridFilters, setGridFilters]: any = React.useState<GridFilterModel>();
  const [yearTrue, setYearTrue] = React.useState(false);
  const selectedFiltersList = AuthUtils.getSelectedCheckBoxList();
  const [selectionModel, setSelectionModel] =
    React.useState<GridRowSelectionModel>(selectedFiltersList);
  const getLocaleStorageData = AuthUtils.getSelectedCheckBoxData();
  const getAdditionalLocaleStorageData =
    AuthUtils.getSelectedAdditionalCheckBoxData();
  const getPatientAccoutningCheckData =
    AuthUtils.getPatientAccountingSelectedCheckBoxList();
  const getPatientAccoutningData =
    AuthUtils.getSelectedPatientAccountingCheckBoxData();
  // Context

  // console.log('shouldFocusQuickFilter--', shouldFocusQuickFilter);
  const previousFilterModelRef = React.useRef<GridFilterModel | null>(null);

  const {SelectedCheckBoxState} = useSelectedCheckBoxContext();

  const record_id = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_RECORD_ID
  );
  const localSearch = EncryptUtils.getDecryptedData(
    location?.search,
    LOCAL_SEARCH
  );

  const search_context = EncryptUtils.getDecryptedData(
    location?.search,
    SEARCH_CONTEXT
  );
  const baseDataGridRow = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_DATA_GRID_ROW
  );
  const apiRef = useGridApiRef();
  const parsedLocalSearch = localSearch ? JSON.parse(localSearch) : {};
  const isClientSortingEnabled =
    sectionUIData?.client_side_pagination || sortingMode === 'client';

  const setSortedRowsData = React.useCallback(
    (data: any[] = [], sortModel?: GridSortModel) => {
      setRowsData(
        isClientSortingEnabled
          ? sortRowsByModel(data, sortModel || gridSortModel, updatecolumn)
          : withGridRowIds(data)
      );
    },
    [gridSortModel, isClientSortingEnabled, updatecolumn]
  );

  const getResolvedRowId = React.useCallback(
    (row: any) =>
      row?.[GRID_ROW_ID_FIELD] || getRowId?.(row) || row?.id || row?.ID,
    [getRowId]
  );

  const getHeaderNameForFlowsheet = (key: any) => {
    if (key === FormConstants.FLOWSHEETS_SCREENS.PARAMETER_NAME) {
      return FormConstants.FLOWSHEETS_SCREENS.Parameter_Name;
    }
    if (key === FormConstants.FLOWSHEETS_SCREENS.FLOWSHEET_TYPE) {
      return FormConstants.FLOWSHEETS_SCREENS.Flowsheet_Type;
    }
    return key;
  };

  const getHeaderNameForVitals = (key: any) => {
    if (key === FormConstants.VITAL_FIELDS_MAPPING.VITAL_NAME) {
      return FormConstants.VITAL_FIELDS_MAPPING.VitalName;
    }
    return key;
  };

  const getSortAndFilterStatusForFlowSheets = (key: any) => {
    return [
      FormConstants.FLOWSHEETS_SCREENS.PARAMETER_NAME,
      FormConstants.FLOWSHEETS_SCREENS.FLOWSHEET_TYPE
    ].includes(key);
  };

  const getSortAndFilterStatusForVitals = (key: any) => {
    return key === FormConstants.VITAL_FIELDS_MAPPING.VITAL_NAME;
  };

  const dropDownOptions = environment?.dropDownOptionsList?.ResultType || [];

  React.useEffect(() => {
    if (onDataReceiveForGridSearch) {
      onDataReceiveForGridSearch(gridFilters, yearTrue);
    }
  }, []);

  const GridFilterInputSelect = ({
    item,
    applyValue
  }: {
    item: {value: string};
    applyValue: (updatedItem: {value: string}) => void;
  }) => {
    const handleChange = (event: any) => {
      applyValue({...item, value: event.target.value});
    };
    return (
      <Select
        sx={{marginTop: '15px', paddingLeft: '3px'}}
        value={item.value || ''}
        onChange={handleChange}>
        {dropDownOptions.map((option: any) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
    );
  };

  const InputNumberInterval = (props: any) => {
    const {item, applyValue, ...others} = props;
    const filterTimeout = React.useRef<number>();
    const [filterValueState, setFilterValueState] = React.useState<
      [Date | undefined, Date | undefined]
    >(item.value ?? [undefined, undefined]);

    React.useEffect(() => {
      return () => {
        clearTimeout(filterTimeout.current);
      };
    }, []);

    React.useEffect(() => {
      const itemValue = item.value ?? [undefined, undefined];
      setFilterValueState(itemValue);
    }, [item.value]);

    const updateFilterValue = (
      lowerBound: Date | undefined,
      upperBound: Date | undefined
    ) => {
      setFilterValueState([lowerBound, upperBound]);

      applyValue({...item, value: [lowerBound, upperBound]});
    };

    const handleLowerDateChange = (newDate: any) => {
      updateFilterValue(newDate, filterValueState[1]);
    };

    const handleUpperDateChange = (newDate: any) => {
      updateFilterValue(filterValueState[0], newDate);
    };

    return (
      <Box
        sx={{
          display: 'inline-flex',
          flexDirection: 'row',
          alignItems: 'center',
          height: 48,
          pl: '5px',
          width: '100%'
        }}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            onChange={handleLowerDateChange}
            value={filterValueState[0]}
            label="From"
            placeholder="From"
            maxDate={filterValueState[1] ? filterValueState[1] : undefined}
            {...others}
            customInput={
              <TextField
                label="From"
                value={dayjs(filterValueState[0]).format('MM/DD/YYYY')}
                type="text"
                placeholder="MM/DD/YYYY"
              />
            }
            sx={{
              '& .MuiInputLabel-root ': {
                fontSize: '1rem',
                color: 'black',
                transform: filterValueState[0]
                  ? 'translate(14px, -9px) scale(0.75)'
                  : 'translate(14px, 16px) scale(1)'
              },
              '& .MuiInputLabel-root.Mui-focused': {
                transform: 'translate(14px, -9px) scale(0.75)'
              },
              paddingRight: '3px'
            }}
          />

          <DatePicker
            onChange={handleUpperDateChange}
            label="To"
            value={filterValueState[1]}
            minDate={filterValueState[0] ? filterValueState[0] : undefined}
            {...others}
            customInput={
              <TextField
                label="To"
                value={dayjs(filterValueState[1]).format('MM/DD/YYYY')}
                placeholder="MM/DD/YYYY"
                {...others}
              />
            }
            sx={{
              '& .MuiInputLabel-root ': {
                fontSize: '1rem',
                color: 'black',
                transform: filterValueState[1]
                  ? 'translate(14px, -9px) scale(0.75)'
                  : 'translate(14px, 16px) scale(1)'
              },
              '& .MuiInputLabel-root.Mui-focused': {
                transform: 'translate(14px, -9px) scale(0.75)'
              }
            }}
          />
        </LocalizationProvider>
      </Box>
    );
  };

  const GridFilterInputSelect2 = (props: any) => {
    const {item, applyValue, ...others} = props;

    const [selectedValues, setSelectedValues] = useState<string[]>(
      item.value || []
    );

    const handleChange = (event: any, newValue: string[]) => {
      setSelectedValues(newValue);
      applyValue({...item, value: newValue});
    };

    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="flex-start"
        sx={{width: 180, marginTop: '12px'}}>
        <Autocomplete
          multiple
          options={dropDownOptions}
          value={selectedValues}
          onChange={handleChange}
          renderTags={(value, getTagProps) =>
            value.map((option: any, index) => {
              const tagProps = getTagProps({index});
              return (
                <Chip
                  {...tagProps}
                  key={option}
                  label={option}
                  deleteIcon={<ClearIcon />}
                  sx={{height: 24, fontSize: '0.75rem'}}
                />
              );
            })
          }
          renderInput={params => (
            <TextField
              sx={{width: '180px'}}
              {...params}
              variant="standard"
              placeholder="Filter value"
            />
          )}
          {...others}
        />
      </Box>
    );
  };

  const customIsOperator = {
    label: 'Is',
    value: 'is',
    getApplyFilterFn: (filterItem: any) => {
      if (!filterItem.value) {
        return null;
      }
      return ({value}: {value: string}) => value === filterItem.value;
    },
    InputComponent: GridFilterInputSelect,
    InputComponentProps: {type: 'text'}
  };

  const customIsNotOperator = {
    label: 'Is Not',
    value: 'not',
    getApplyFilterFn: (filterItem: any) => {
      if (!filterItem.value) {
        return null;
      }
      return ({value}: {value: string}) => value !== filterItem.value;
    },
    InputComponent: GridFilterInputSelect,
    InputComponentProps: {type: 'text'}
  };

  const customIsAnyOfOperator = {
    label: 'Is Any Of',
    value: 'isAnyOf',
    getApplyFilterFn: (filterItem: GridFilterItem) => {
      if (!filterItem.value || filterItem.value.length === 0) {
        return null;
      }
      return ({value}: {value: string}) => filterItem.value.includes(value);
    },
    InputComponent: GridFilterInputSelect2,
    InputComponentProps: {type: 'text'}
  };

  const customisbetweenoperator = {
    label: 'is between',
    value: 'isbetween',
    getApplyFilterFn: (filterItem: any) => {
      if (!filterItem.value || filterItem.value.length !== 2) {
        return null;
      }
      return ({value}: {value: string}) => {
        if (!value) return false;
        const [lowerBound, upperBound] = filterItem.value;
        const dateTimestamp = getDateSortValue(value);
        const isValidLowerBound = lowerBound
          ? dateTimestamp >= getDateSortValue(lowerBound)
          : true;
        const isValidUpperBound = upperBound
          ? dateTimestamp <= getDateSortValue(upperBound)
          : true;
        return isValidLowerBound && isValidUpperBound;
      };
    },
    InputComponent: InputNumberInterval,
    InputComponentProps: {type: 'date'},
    sx: {fontSize: '0.75rem'}
  };

  const customContainsOperator = {
    label: 'Contains',
    value: 'contains',
    getApplyFilterFn: (filterItem: any) => {
      if (!filterItem.value) {
        return null;
      }
      return ({value}: {value: string}) =>
        value && value.includes(filterItem.value);
    },
    InputComponent: GridFilterInputValue,
    InputComponentProps: {type: 'text'}
  };

  const dateOperators = getGridDateOperators();
  const filterMap = React.useMemo(() => {
    const map: Record<string, GridFilterItem> = {};
    gridFilters?.items?.forEach((item: GridFilterItem) => {
      if (item.field) map[item.field] = item;
    });
    return map;
  }, [gridFilters]);
  // Use React.useMemo to memoize the columns
  const newcolumns = React.useMemo(
    () =>
      updatecolumn.map((col: any) => {
        const includeMinWidth = props.displayHorizontalScroll;
        const minWidthValue = col.minWidth || 110;
        const isFiltered = !!filterMap[col.field];

        // Shared enhancements for all filtered columns
        const baseColumn = {
          ...col,
          ...(includeMinWidth && {minWidth: minWidthValue}),
          ...(isFiltered && {
            cellClassName: 'highlight-filtered-cell',
            renderHeader: (params: any) => {
              const filter = filterMap[col.field];
              const title =
                filter?.operator && filter?.value
                  ? `${filter.operator} ${Array.isArray(filter.value) ? filter.value.join(', ') : filter.value}`
                  : '';
              return <span title={title}>{params.colDef.headerName}</span>;
            }
          })
        };
        // Apply custom filter operators for 'ResultType' field if sub_module is 'results'
        if (col.field === 'ResultType' && sub_module === 'results') {
          return {
            ...baseColumn,
            ...(includeMinWidth && {minWidth: minWidthValue}),
            filterOperators: [
              ...(col.filterOperators || []),
              customIsOperator,
              customIsNotOperator,
              customIsAnyOfOperator,
              customContainsOperator
            ]
          };
        }

        // For date or date-time columns, add custom filter operators and a custom renderCell
        if (isDateColumnType(col.column_type)) {
          return {
            ...baseColumn,
            ...(includeMinWidth && {minWidth: minWidthValue}),
            filterOperators: [
              ...(col.filterOperators || []),
              ...dateOperators,
              customisbetweenoperator
            ],
            sortComparator: (valueA: any, valueB: any) =>
              getDateSortValue(valueA) - getDateSortValue(valueB),
            valueFormatter: ({value}: any) =>
              formatGridDateValue(value, col.column_type),
            renderCell: (params: any) => {
              return formatGridDateValue(params.value, col.column_type);
            }
          };
        }

        // Return column without changes if no conditions are met
        return {
          ...baseColumn,
          ...(includeMinWidth && {minWidth: minWidthValue})
        };
      }),
    [updatecolumn, props.displayHorizontalScroll]
  );

  useEffect(() => {
    if (
      sub_module === 'vital' ||
      sub_module === 'auto-post' ||
      sub_module === 'ar-worklist' ||
      (sub_module === 'flowsheets' && props?.rows[0] !== 'submoduledatapassed')
    ) {
      if (sub_module === 'vital' && props?.rows[0]?.VitalName === '') {
        setRowsData([]);
      } else {
        setSortedRowsData(props?.rows);
      }
    }
  }, [props?.rows, sub_module, setSortedRowsData]);

  useEffect(() => {
    if (props?.module === 'patient-accounting') {
      /* No need to set sectionUIData to default */
    } else {
      if (sub_module !== 'vital' && sub_module !== 'flowsheets') {
        setRowsData([]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sectionUIData]);
  const getUpdatedColumnsLIS = (columnItem: any) => {
    const columnList: any[] = [];

    Object.entries(columnItem).forEach(([key]) => {
      if (!key || key === 'ID') return;

      const isVitalName = key === 'VitalName';

      columnList.push({
        field: key,
        headerName: isVitalName ? FormConstants.VITAL_SCREENS.VitalName : key,
        minWidth: 180,

        sortable: isVitalName,
        filterable: isVitalName,
        disableColumnMenu: !isVitalName,
        pinnable: isVitalName,

        renderCell: (params: any) => {
          const cellValue = params?.value ?? '';

          const isPointer =
            typeof cellValue === 'string' &&
            cellValue.includes(FormConstants.VITAL_SCREENS.ID_KEY);

          return (
            <Typography
              sx={{cursor: isPointer ? 'pointer' : 'default'}}
              color={isPointer ? 'primary' : ''}>
              {isPointer
                ? cellValue.split(FormConstants.VITAL_SCREENS.ID_KEY)[0]
                : cellValue}
            </Typography>
          );
        }
      });
    });

    return columnList;
  };

  const getUpdatedColumns = (columnItem: any, inputName: any) => {
    const columnList: any = [];
    Object.entries(columnItem).forEach(([key, value]) => {
      if (inputName === FormConstants.SCREENS.FLOWSHEETS) {
        const obj = {
          field: key,
          headerName: getHeaderNameForFlowsheet(key),
          width: 180,
          valueGetter: (data: any) =>
            data.type === FormConstants.CONFIG_FIELDS_TYPE.DATE ||
            data.type === FormConstants.CONFIG_FIELDS_TYPE.DATE_TIME
              ? new Date(data.value)
              : data.value,
          renderCell: (ele: any) => {
            const valueString = ele?.value?.toString();
            return (
              <Typography
                sx={{
                  cursor: valueString?.includes(
                    FormConstants.FLOWSHEETS_SCREENS.ID_KEY
                  )
                    ? 'pointer'
                    : 'default'
                }}
                color={
                  valueString?.includes(FormConstants.FLOWSHEETS_SCREENS.ID_KEY)
                    ? 'primary'
                    : ''
                }>
                {
                  valueString?.split(
                    FormConstants.FLOWSHEETS_SCREENS.ID_KEY
                  )?.[0]
                }
              </Typography>
            );
          },
          sortable: getSortAndFilterStatusForFlowSheets(key),
          filterable: getSortAndFilterStatusForFlowSheets(key)
        };

        columnList.push(obj);
      } else {
        const obj = {
          field: key,
          headerName: getHeaderNameForVitals(key),
          width: 180,
          valueGetter: (data: any) =>
            data.type === FormConstants.CONFIG_FIELDS_TYPE.DATE ||
            data.type === FormConstants.CONFIG_FIELDS_TYPE.DATE_TIME
              ? new Date(data.value)
              : data.value,
          renderCell: (ele: any) => {
            return (
              <Typography
                sx={{
                  cursor:
                    (typeof ele?.value === 'string' &&
                      ele.value.includes(FormConstants.VITAL_SCREENS.ID_KEY)) ||
                    (Array.isArray(ele?.value) &&
                      ele.value.some((v: any) =>
                        v.includes(FormConstants.VITAL_SCREENS.ID_KEY)
                      )) ||
                    typeof ele?.value === 'number'
                      ? 'pointer'
                      : 'default'
                }}
                color={
                  (typeof ele?.value === 'string' &&
                    ele.value.includes(FormConstants.VITAL_SCREENS.ID_KEY)) ||
                  (Array.isArray(ele?.value) &&
                    ele.value.some((v: any) =>
                      v.includes(FormConstants.VITAL_SCREENS.ID_KEY)
                    )) ||
                  typeof ele?.value === 'number'
                    ? 'primary'
                    : ''
                }>
                {typeof ele?.value === 'string'
                  ? ele.value.split(FormConstants.VITAL_SCREENS.ID_KEY)?.[0]
                  : typeof ele?.value === 'number'
                    ? ele.value.toString()
                    : ''}
              </Typography>
            );
          },
          sortable: getSortAndFilterStatusForVitals(key),
          filterable: getSortAndFilterStatusForVitals(key)
        };

        columnList.push(obj);
      }
    });

    return columnList;
  };

  const getSortField = (sortModel: any) => {
    let model = sortModel?.[0]?.field;
    const obj = sectionUIData?.fields?.find(
      (item: any) => item?.data_column === sortModel?.[0]?.field
    );
    const shouldCastSortFieldAsText =
      typeof model === 'string' && /comment/i.test(model);

    if (obj && Object.keys(obj).length > 0 && obj?.isSchemaRequired) {
      if (obj?.dynamic_column) {
        model =
          getSqlSortExpression(
            obj?.schema,
            sortModel?.[0]?.field,
            shouldCastSortFieldAsText
          ) || model;
      } else {
        model = obj?.schema + '.' + sortModel?.[0]?.field;
      }
    } else if (
      hasSqlFieldReference(
        sectionUIData?.sql_data?.sql,
        sectionUIData?.sql_data?.filter_schema_clause,
        model
      )
    ) {
      model =
        getSqlSortExpression(
          sectionUIData.sql_data.filter_schema_clause,
          model,
          shouldCastSortFieldAsText
        ) || model;
    }
    // if (model) {
    //   return `[${model}]`;
    // }

    return model;
  };

  // check this - 4
  const formatResponseDataFields = (column: any, res: any) => {
    setupdatedcolumn(column);
    const finalUpdatedColumns = column || updatecolumn;
    finalUpdatedColumns.forEach((columnItem: any) => {
      if (columnItem.column_type) {
        if (isDateColumnType(columnItem.column_type)) {
          return;
        }

        const data = res.data.rows || res.data;
        for (const rowItem of data) {
          const rowData = HelperUtils.formatData(
            rowItem[columnItem.field],
            columnItem.column_type,
            columnItem.format || columnItem.formatter || columnItem.column_type
          );

          rowItem[columnItem.field] = rowData;
        }
      }
    });
  };

  // flow sheet expandable data grid
  const isGroupExpandedByDefault = (node: any) =>
    node.groupingField === ExpandableRowInFlowSheets?.field &&
    node.groupingKey === ExpandableRowInFlowSheets?.id;
  const handleRemoveChildTabName = (item: string) => {
    const query = new URLSearchParams(location.search);
    const encrypted = query.get(PARAMS_KEY);

    if (!encrypted) return;

    const decryptedParams = EncryptUtils.getDecryptedParams(encrypted);
    delete decryptedParams[item]; // Remove the field

    const newEncrypted = EncryptUtils.setEncryptedParams(decryptedParams);
    query.set(PARAMS_KEY, newEncrypted);

    // Optional: remove other keys if needed (like BASE_MENU_ITEM)
    // query.delete(BASE_MENU_ITEM);

    // Replace the route without reloading
    navigate(`${location.pathname}?${query.toString()}`, {replace: true});
  };
  const init = async (
    fetching?: boolean,
    limit?: number,
    offset?: any,
    sortModel?: any,
    filterModel?: any,
    isYearTrue?: any
  ) => {
    // if radio box changes selected row check boxes will be deselected in clinical reports
    try {
      if (onDataReceiveForGridSearch) {
        onDataReceiveForGridSearch(
          filterModel,
          isYearTrue,
          sortModel,
          offset,
          limit
        );
      }
      let visitDetails;
      if (baseDataGridRow) {
        visitDetails = JSON.parse(baseDataGridRow);
      }

      // new find dateor time funtion
      // if radio box changes selected row check boxes will be deselected in clinical reports
      if (
        (module === FormConstants.MODULE.CLINICAL &&
          sub_module === FormConstants.SUB_MODULE.REPORTS) ||
        sectionUIData?.name === FormConstants.REPORTS_SCREENS.TAB ||
        sectionUIData?.name === FormConstants.REPORTS_SCREENS.SUB_TAB
      ) {
        setSelectionModel([]);
      }
      const SendEncounterNumber = () => {
        let filterEncounterNumber: any;
        const filteredArray: any = [];
        let parsedData;
        if (getLocaleStorageData) {
          try {
            parsedData = JSON.parse(getLocaleStorageData);
          } catch (error) {
            console.error('Error parsing localStorage data:', error);
          }
          if (parsedData) {
            filterEncounterNumber = JSON.parse(getLocaleStorageData);
            filterEncounterNumber?.map((entry: any) =>
              filteredArray.push(entry.EncounterNumber)
            );
          }
        }
        if (
          getAdditionalLocaleStorageData &&
          localStorage.getItem('patient_encounterData_removed') === 'false'
        ) {
          try {
            parsedData = JSON.parse(getAdditionalLocaleStorageData);
          } catch (error) {
            console.error('Error parsing localStorage data:', error);
          }
          if (parsedData) {
            filterEncounterNumber = JSON.parse(getAdditionalLocaleStorageData);
            filterEncounterNumber?.map((entry: any) =>
              filteredArray.push(entry.EncounterNumber)
            );
          }
        }

        return filteredArray;
      };

      if (
        module &&
        (sub_module ||
          sectionUIData.name === FormConstants.REPORTS_SCREENS.TAB ||
          sectionUIData.name === FormConstants.REPORTS_SCREENS.SUB_TAB) &&
        sectionUIData?.sql_data?.variables &&
        sectionUIData?.sql_data?.sql &&
        (selectedRowDetails ||
          recordId ||
          sectionUIData.name === FormConstants.REPORTS_SCREENS.TAB ||
          sectionUIData.name === FormConstants.REPORTS_SCREENS.SUB_TAB ||
          sectionUIData.name === FormConstants.SCREENS.VITAL ||
          sectionUIData.sub_name === FormConstants.VITAL_SCREENS.GROWTH_CHART ||
          sectionUIData.name === FormConstants.SCREENS.FLOWSHEETS)
      ) {
        setLoader(true);

        const accountlocalstorage = localStorage.getItem('account_number_id');
        const encounterLocalStorage = localStorage.getItem(
          'encounter_number_id'
        );
        const invoiceNumberLocalStorage =
          localStorage.getItem('invoice_number');

        const payload: any = {
          sortNeeded: sectionUIData?.sql_data?.sortNedded,
          count_query_sql: sectionUIData?.count_query_sql,
          user_id: recordId || record_id,
          patient_visit_id:
            selectedRowDetails?.row?.PatientVisitId ||
            visitDetails?.PatientVisitID,
          sql_data: sectionUIData?.sql_data,
          record_id:
            selectedRowDetails?.row?.ID || selectedRowDetails?.id || recordId,
          PlanName: selectedRowDetails?.row?.PlanName,
          BenefitType: selectedRowDetails?.row?.BenefitType,
          EffectiveDt: selectedRowDetails?.row?.EffectiveDt,
          PlanType: selectedRowDetails?.row?.PlanType,
          OrderID: selectedRowDetails?.row?.OrderID,
          OrderName: selectedRowDetails?.row?.OrderName,
          HistoryLinkID: selectedRowDetails?.row?.HistoryLinkID,
          ResultStatus: selectedRowDetails?.row?.ResultStatus,
          OrderDate: selectedRowDetails?.row?.orderDateValue,
          parentLegacyApp:
            selectedRowDetails?.row?.ParentLegacyValue ?? ParentLegacyValue,
          filter_schema_clause: sectionUIData?.sql_data?.filter_schema_clause,
          legacyApp: selectedRowDetails?.row?.legacyApp || legacyApp,
          PatientAccountinglegacyApp:
            getAdditionalLocaleStorageData &&
            localStorage.getItem('patient_encounterData_removed') &&
            localStorage.getItem('patient_encounterData_removed') === 'false' &&
            JSON.parse(getAdditionalLocaleStorageData)[0].legacyApp,
          PatientAccountinglegacyMRN:
            getAdditionalLocaleStorageData &&
            localStorage.getItem('patient_encounterData_removed') &&
            localStorage.getItem('patient_encounterData_removed') === 'false' &&
            JSON.parse(getAdditionalLocaleStorageData)[0].LegacyMRN,
          legacyMRN: selectedRowDetails?.row?.legacyMRN,
          generic_name: selectedRowDetails?.row?.GenericName,
          brand_name: selectedRowDetails?.row?.BrandName,
          route_of_administration:
            selectedRowDetails?.row?.RouteOfAdministration,
          item_vendor_id: selectedRowDetails?.row?.ItemVendorID,
          transaction_id: selectedRowDetails?.row?.TransactionID,
          invoice_id: selectedRowDetails?.row?.InvoiceID,
          employment_number: selectedRowDetails?.row?.EmpNo,
          type: selectedRowDetails?.row?.Type,
          year: selectedRowDetails?.row?.Year,
          pay_date: selectedRowDetails?.row?.PayDate,
          distribution_order: selectedRowDetails?.row?.DistributionOrder,
          is_active: selectedRowDetails?.row?.IsActive,
          is_dependent: selectedRowDetails?.row?.IsDependent,
          priority: selectedRowDetails?.row?.Priority,
          PatientAccountingEncounterDate:
            getAdditionalLocaleStorageData &&
            localStorage.getItem('patient_encounterData_removed') &&
            localStorage.getItem('patient_encounterData_removed') === 'false' &&
            JSON.parse(getAdditionalLocaleStorageData)[0].EncounterDate,
          PatientAccountingEncounterNumber:
            getAdditionalLocaleStorageData &&
            localStorage.getItem('patient_encounterData_removed') &&
            localStorage.getItem('patient_encounterData_removed') === 'false'
              ? JSON.parse(getAdditionalLocaleStorageData)[0].EncounterNumber
              : encounterLocalStorage,
          EncounterDate: selectedRowDetails?.row?.EncounterDate,
          EncounterNumber: selectedRowDetails?.row?.EncounterNumber,
          AssessmentType: selectedRowDetails?.row?.AssessmentType,
          AssessmentElement: selectedRowDetails?.row?.AssessmentElement,
          AssessmentCategory: selectedRowDetails?.row?.AssessmentCategory,
          AssessmentDate: selectedRowDetails?.row?.AssessmentDate,
          audit_sub_module_identifier: generateSubModuleIdentifier(
            module,
            sub_module,
            {
              specimen_number_id,
              procedure_id,
              procedure_type,
              demographic_id,
              row_id: selectedRowDetails?.row?.ID,
              patient_visit_id:
                selectedRowDetails?.row?.PatientVisitId ||
                visitDetails?.PatientVisitID,
              ID: selectedRowDetails?.row?.ID || recordId,
              sub_module_identifier_id:
                sectionUIData?.sql_data?.sub_module_identifier_id
            }
          ),
          patient_info_id: selectedRowDetails?.row?.PatientInformationID,
          prescription_no: selectedRowDetails?.row?.PrescriptionNumber,
          drug: selectedRowDetails?.row?.Drug,
          refill_no: selectedRowDetails?.row?.RefillNumber,
          ndc: selectedRowDetails?.row?.NDC,
          localEncounterNumber: SendEncounterNumber(),
          StartDate: selectedRowDetails?.row?.start_date,
          StopDate: selectedRowDetails?.row?.stop_date,
          FlowsheetGroup: selectedRowDetails?.row?.FlowsheetGroup,
          LegacyAppGroup: selectedRowDetails?.row?.LegacyAppGroup,
          audit_identifier: AuthUtils.getAuditIdentifier(),
          audit_identifier_type: AuthUtils.getAuditIdentifierType(),
          audit_legacy_app: AuthUtils.getAuditLegacyApp(),
          isBH_selected: sectionUIData?.sql_data?.ignoreIsBH
            ? 'ignore_isBH'
            : isBH,
          isBH_reason: isBHReason,
          application_name: applicationName,
          limit:
            openning &&
            deleteDocument &&
            sectionUIData.name === 'previous_report_log'
              ? limited
              : limit,
          offset:
            openning &&
            deleteDocument &&
            sectionUIData.name === 'previous_report_log'
              ? offseted
              : offset,
          sort_by: sectionUIData?.sql_data?.schema_clause
            ? `${sectionUIData?.sql_data?.schema_clause}.${sortModel?.[0]?.field}`
            : getSortField(sortModel),
          sort: sortModel?.[0]?.sort,
          procedure_type: procedure_type,
          accession_number: accession_number,
          pharmcymrn: selectedRowDetails?.row?.LegacyMRN,
          specimen_number:
            specimen_number || selectedRowDetails?.row?.SpecimenNumber,
          specimen_number_id: specimen_number_id,
          procedure_id: procedure_id,
          demographic_id: demographic_id,
          test_name: selectedRowDetails?.row?.TestName,
          account_number: accountlocalstorage,
          LegacyMRN: selectedRowDetails?.row?.LegacyMRN,
          TransfusionID: props?.TransfusionID
        };
        if (invoiceNumberLocalStorage) {
          payload.InvoiceNumber = invoiceNumberLocalStorage;
        }

        if (
          sectionUIData?.is_filter_sql_required &&
          getLocaleStorageData.length > 0
        ) {
          payload.filter_data = getLocaleStorageData;
        }

        if (
          props?.module === 'patient-accounting' &&
          props?.sub_module === 'invoice' &&
          selectedRowDetails?.row?.IsRCMTransaction
        ) {
          payload.IsRCMTransaction = true;
        }

        if (filterModel?.items?.length > 0) {
          // const filteredTypes =
          // filterModel && filterModel.items
          //   ? getColumnTypes(updatecolumn, filterModel)
          //   : [];
          payload.filtertype = isYearTrue;
          payload.filterModel = filterModel?.items;
          payload.logicOperator = filterModel?.logicOperator;
          payload.filter_schema_clause =
            sectionUIData?.sql_data?.filter_schema_clause;
        }
        payload.start_month_year = BenefitsPayload?.start_month_year || '';
        payload.end_month_year = BenefitsPayload?.end_month_year || '';
        if (parsedLocalSearch?.is_local_search && parsedLocalSearch?.ID) {
          const params = new URLSearchParams(window.location.search);
          const encrypted = params.get(PARAMS_KEY);
          const {local_search} = EncryptUtils.getDecryptedParams(encrypted);
          const latest_parsedLocalSearch = local_search?.length
            ? JSON.parse(local_search)
            : null;

          payload.local_search = parsedLocalSearch?.is_local_search;
          payload.local_search_ID =
            latest_parsedLocalSearch?.nested_ID ?? parsedLocalSearch?.ID;
          payload.local_search_isBhdatafilter =
            parsedLocalSearch?.ISBhdataFilter;
          if (
            sectionUIData.name?.toLowerCase() ===
            parsedLocalSearch?.Level2?.toLowerCase()
          ) {
            payload.local_search_ID = parsedLocalSearch?.Level2ID;
          }
        }

        if (
          sub_module === FormConstants.SCREENS.VITAL &&
          sectionUIData.sub_name === FormConstants.VITAL_SCREENS.GROWTH_CHART
        ) {
          payload.sub_name = sectionUIData.sub_name;
        }

        if (setopening) {
          setopening(false);
        }
        if (setDeleteDocument) {
          setDeleteDocument(false);
        }

        const encryptRequestData: any = EncryptUtils.encryptedData(payload);

        const res = await getPageData(
          applicationName,
          module,
          sub_module || FormConstants.SUB_MODULE.REPORTS,
          {
            tk: encryptRequestData
          }
        );
        setRowCount(res?.count?.[0]?.count || 0);
        // check this
        if (setRowsCountData && typeof setRowsCountData === 'function') {
          setRowsCountData(res?.count?.[0]?.count || 0);
        }
        if (setRowsPAData && typeof setRowsPAData === 'function') {
          setRowsPAData(res?.data);
        }
        if (
          params.module_name === FormConstants.MODULE.LIS &&
          params.submodule_name === FormConstants.SUB_MODULE.PRODUCTINFO &&
          sectionUIData?.sql_data?.grid_name === 'VitalsDetails'
        ) {
          const colum = getUpdatedColumnsLIS(res?.data?.[0] || {});

          const rows = (res?.data || []).map((row: any, index: number) => ({
            id: index + 1,
            ...row
          }));

          formatResponseDataFields(colum, res);
          setSortedRowsData(rows, sortModel);
          setLoader(false);
        } else if (
          sub_module === FormConstants.SCREENS.FLOWSHEETS ||
          (sub_module === FormConstants.SCREENS.VITAL &&
            sub_module === sectionUIData?.name)
        ) {
          const colum = getUpdatedColumns(res?.data?.[0] || [], sub_module);
          formatResponseDataFields(colum, res);
          if (res?.count?.[0]?.count !== 0) {
            setSortedRowsData(res?.data, sortModel);
          } else {
            setRowsData([]);
          }
          setLoader(false);
        } else {
          formatResponseDataFields(columns, res);
          setSortedRowsData(res?.data, sortModel);
          setLoader(false);
        }
        if (
          sub_module === 'accounts' &&
          accountlocalstorage &&
          localStorage.getItem('account_number_fetched') === 'false'
        ) {
          const ids = res?.data
            ? res?.data.map((item: {ID: any}) => item.ID)
            : [];
          setSelectionModel(ids);
          handleOnSelectionModelChange({
            ids: ids,
            data: res?.data
          });
        }
        if (
          sub_module === 'encounters' &&
          encounterLocalStorage &&
          localStorage.getItem('account_number_fetched') === 'false'
        ) {
          const ids = res?.data
            ? res?.data.map((item: {ID: any}) => item.ID)
            : [];

          if (ids.length === 0) {
            localStorage.setItem('encounterIsBH', 'false');
            const encounterDate = localStorage.getItem('account_number_date');
            const encounterDateID = localStorage.getItem(
              'account_number_Date_id'
            );
            const encounterLegacyApp = localStorage.getItem(
              'account_number_Legacy_App'
            );
            const encounterLegacyMRN = localStorage.getItem(
              'account_number_Legacy_Mrn'
            );
            if (encounterDateID) {
              setSelectionModel([Number(encounterDateID)]);
            }
            handleOnSelectionModelChange({
              ids: [Number(encounterDateID)],
              data: [
                {
                  ID: Number(encounterDateID),
                  EncounterNumber: encounterLocalStorage,
                  EncounterDate: encounterDate,
                  LegacyApp: encounterLegacyApp,
                  LegacyMRN: encounterLegacyMRN
                }
              ]
            });
          } else {
            localStorage.setItem('encounterIsBH', 'true');
            setSelectionModel(ids);
            handleOnSelectionModelChange({
              ids: ids,
              data: res?.data
            });
          }
        }
        if (
          sub_module === 'encounters' &&
          getAdditionalLocaleStorageData &&
          localStorage.getItem('patient_encounterData_removed') === 'false'
        ) {
          const ids = res?.data
            ? res?.data.map((item: {ID: any}) => item.ID)
            : [];
          if (ids.length === 0) {
            localStorage.setItem('encounterIsBH', 'false');
          } else {
            localStorage.setItem('encounterIsBH', 'true');
          }
          setSelectionModel(ids);
          handleOnSelectionModelChange({
            ids: ids,
            data: res?.data
          });
        }
        if (
          sub_module === 'accounts' &&
          getAdditionalLocaleStorageData &&
          localStorage.getItem('patient_encounterData_removed') === 'true'
        ) {
          const invoiceData = res?.data?.find(
            (item: {ID: any}) =>
              item.ID ===
              JSON.parse(getAdditionalLocaleStorageData)[0].ParentTable
          );
          if (invoiceData && props?.setExpandedRowIds) {
            props?.setExpandedRowIds([invoiceData?.ID]);
            // handleRemoveChildTabName(INVOICE_NUMBER);
            localStorage.setItem('invoice_number_fetched', invoiceData?.ID);
          }

          if (getPatientAccoutningCheckData) {
            const ids = getPatientAccoutningCheckData.map(
              (item: {ID: number}) => {
                return item.ID;
              }
            );
            setSelectionModel(ids);
            handleOnSelectionModelChange({
              ids: ids,
              data: res?.data
            });
            localStorage.setItem('encounterIsBH', 'true');
            localStorage.setItem('account_number_fetched', 'false');
          }
          AuthUtils.clearAdditionalSelectedCheckBoxList();
          // AuthUtils.clearPatientAccountingSelectedCheckBoxList();
          AuthUtils.clearSelectedPatientAccountingCheckBoxData();
          AuthUtils.clearSelectedAdditionalCheckBoxData();
          AuthUtils.clearAdditionalSelectedCheckBoxList();
          localStorage.removeItem('PATabledata');
        }
        if (invoiceNumber) {
          const invoiceData = res?.data?.find(
            (item: {InvoiceNumber: any}) => item.InvoiceNumber === invoiceNumber
          );
          if (invoiceData && props?.setExpandedRowIds) {
            props?.setExpandedRowIds([invoiceData?.ID]);
            // handleRemoveChildTabName(INVOICE_NUMBER);
            localStorage.setItem('invoice_number_fetched', invoiceData?.ID);
          }
        }
        if (childTabName) {
          const data = localStorage.getItem('invoice_number_fetched');

          if (sectionUIData?.end_tab_linked && data !== null) {
            // localStorage.removeItem('invoice_number_fetched');
            // handleRemoveChildTabName(CHILD_TAB_NAME);
            localStorage.removeItem('invoice_number_fetched');
            AuthUtils.clearAdditionalSelectedCheckBoxList();
            AuthUtils.clearSelectedAdditionalCheckBoxData();
          }
        }
        if (sectionUIData?.pinned_rows) {
          payload.sql_data = sectionUIData?.pinned_rows_sql;
          const encryptRequestData: any = EncryptUtils.encryptedData(payload);

          const pinnedRes = await getPageData(
            applicationName,
            module,
            sub_module || FormConstants.SUB_MODULE.REPORTS,
            {
              tk: encryptRequestData
            }
          );

          const pinnedRowData = pinnedRes.data[0];

          if (pinnedRowData) {
            const pinnedColumns = sectionUIData?.pinned_rows_sql?.fields;

            // Iterate through each column and format corresponding data in pinnedRowData
            const formattedPinnedRowData = pinnedColumns.reduce(
              (acc: any, column: any) => {
                const value = pinnedRowData[column.data_column]; // Get value from pinnedRowData for the current column

                // Use HelperUtils.formatData() to format the value
                const formattedValue = HelperUtils.formatData(
                  value,
                  column.type, // The type to pass to the formatData function
                  column.formatter // The formatter (optional, might be undefined)
                );

                // Concatenate column label with the formatted value
                const concatenatedValue = `${column.label}: ${formattedValue}`;

                // Assign concatenated value to the accumulator
                acc[column.data_column] = concatenatedValue;
                return acc;
              },
              {}
            );
            //dummy ID for pinned_row_sql
            formattedPinnedRowData.ID = 1000;
            setPinnedRows([formattedPinnedRowData]); // Set the formatted pinned row data
          } else {
            setPinnedRows([]);
          }
        }
      } else if (
        module &&
        sectionUIData?.sql_data?.variables &&
        sectionUIData?.sql_data?.sql &&
        !sectionUIData?.is_clinical_module_report &&
        // props?.loading === false ||  &&
        (props?.rows === undefined ||
          props?.rows === null ||
          props?.rows.length === 0 ||
          fetching)
      ) {
        setLoader(true);

        Object.freeze(searchFormFieldsData);
        const dupSearchFormFieldsData = {...searchFormFieldsData};
        dupSearchFormFieldsData.limit = limit
          ? limit
          : environment?.defaultRowsLimit;
        dupSearchFormFieldsData.offset = offset || '';
        dupSearchFormFieldsData.sort = sortModel?.[0]?.sort || '';
        dupSearchFormFieldsData.sort_by = getSortField(sortModel);
        dupSearchFormFieldsData.sql_data = sectionUIData?.sql_data;
        dupSearchFormFieldsData.recent_patients = sectionUIData?.heading;
        dupSearchFormFieldsData.record_id =
          selectedRowDetails?.row?.ID || selectedRowDetails?.id || recordId;
        dupSearchFormFieldsData.mpi_number = selectedRowDetails?.row?.MPINumber;
        dupSearchFormFieldsData.report_account_number =
          selectedRowDetails?.row?.AccountNumber;
        dupSearchFormFieldsData.account_description =
          selectedRowDetails?.row?.AccountDescription;
        if (filterModel?.items?.length > 0) {
          dupSearchFormFieldsData.filterModel = filterModel?.items;
          dupSearchFormFieldsData.logicOperator = filterModel?.logicOperator;
          dupSearchFormFieldsData.filter_schema_clause =
            sectionUIData?.sql_data?.filter_schema_clause;
        }
        const encryptRequestData: any = EncryptUtils.encryptedData(
          dupSearchFormFieldsData
        );
        const res = await getSearchResultsData(applicationName, module, {
          tk: encryptRequestData
        });
        formatResponseDataFields(columns, res);
        setRowCount(res?.count?.[0]?.count || 0);
        if (setRowsCountData && typeof setRowsCountData === 'function') {
          setRowsCountData(res?.count?.[0]?.count || 0);
        }
        if (setRowsPAData && typeof setRowsPAData === 'function') {
          setRowsPAData(res?.data);
        }
        setSortedRowsData(res?.data, sortModel);
        setLoader(false);
      } else if (
        // eslint-disable-next-line no-dupe-else-if
        module &&
        !isFromModules &&
        sectionUIData?.sql_data?.variables &&
        sectionUIData?.sql_data?.sql &&
        sectionUIData?.sql_data?.schema &&
        !rowsData?.length
      ) {
        setLoader(true);
        const data = {
          dob: subModuleData?.dob,
          first_name: subModuleData?.first_name,
          last_name: subModuleData?.last_name,
          name: subModuleData?.name,
          mrn: subModuleData?.mrn,
          sql_data: sectionUIData?.sql_data
        };

        if (!data.dob) delete data.dob;
        if (!data.first_name) delete data.first_name;
        if (!data.last_name) delete data.last_name;
        if (!data.name) delete data.name;
        if (!data.mrn) delete data.mrn;
        const encryptRequestData =
          module === FormConstants.MODULE.AUDIT_LOGS
            ? {}
            : EncryptUtils.encryptedData(data);

        const res = await getSearchResultsData(applicationName, module, {
          tk: encryptRequestData
        });
        formatResponseDataFields(columns, res);
        setRowCount(res?.count?.[0]?.count || rowCount);
        if (setRowsCountData && typeof setRowsCountData === 'function') {
          setRowsCountData(res?.count?.[0]?.count || 0);
        }
        if (setRowsPAData && typeof setRowsPAData === 'function') {
          setRowsPAData(res?.data);
        }
        setSortedRowsData(res?.data, sortModel);
        setLoader(false);
      } else if (module === FormConstants.MODULE.AUDIT_LOGS) {
        const payload: any = {
          sort_by: getSortField(sortModel) || '',
          sort: sortModel?.[0]?.sort || ''
        };

        if (filterModel?.items?.length > 0) {
          payload.filterModel = filterModel?.items;
          payload.logicOperator = filterModel?.logicOperator;
          payload.filter_schema_clause =
            sectionUIData?.sql_data?.filter_schema_clause;
        }

        setLoader(true);
        if (sectionUIData?.is_access_logs) {
          payload.limit = limit || environment?.defaultRowsLimit;
          payload.offset = offset || 0;

          const encryptRequestData = EncryptUtils.encryptedData(payload);

          const res: any = await getUserAccessAuditsData({
            tk: encryptRequestData
          });
          if (columns && columns.length) {
            formatResponseDataFields(columns, res);
          }
          setLoader(false);
          setSortedRowsData(res?.data?.rows, sortModel);
          setRowCount(res?.data?.count?.[0]?.count);
          if (setRowsCountData && typeof setRowsCountData === 'function') {
            setRowsCountData(res?.data?.count?.[0]?.count);
          }
          if (setRowsPAData && typeof setRowsPAData === 'function') {
            setRowsPAData(res?.data);
          }
        } else if (sectionUIData?.is_application_logs) {
          payload.limit = limit || environment?.defaultRowsLimit;
          payload.offset =
            gridPageSize?.current && offset
              ? offset / gridPageSize.current + 1
              : 1;

          const encryptRequestData = EncryptUtils.encryptedData(payload);

          const res: any = await getUserAuditsData({
            tk: encryptRequestData
          });
          if (columns && columns.length) {
            formatResponseDataFields(columns, res);
          }
          setLoader(false);
          setSortedRowsData(res?.data?.rows, sortModel);
          setRowCount(res?.data?.count);
          if (setRowsCountData && typeof setRowsCountData === 'function') {
            setRowsCountData(res?.data?.count);
          }
          if (setRowsPAData && typeof setRowsPAData === 'function') {
            setRowsPAData(res?.data);
          }
        } else {
          setSortedRowsData(props?.rows || rowsData, sortModel);
          setRowCount(props?.rowCount || rowCount);
          if (setRowsCountData && typeof setRowsCountData === 'function') {
            setRowsCountData(props?.rowCount || rowCount);
          }
          setLoader(false);
        }
      } else if (module === FormConstants.MODULE.USER_ACCESS) {
        setLoader(true);

        const data: any = {
          limit: limit || environment?.defaultRowsLimit,
          offset: offset || 0,
          sort_by: getSortField(sortModel) || '',
          sort: sortModel?.[0]?.sort || '',
          org_id: '',
          sql_data: {
            is_audit: true,
            audit_event_description: FormConstants.COMMON.VIEWED_USERS
          }
        };

        if (filterModel?.items?.length > 0) {
          data.filterModel = filterModel?.items;
          data.logicOperator = filterModel?.logicOperator;
          data.filter_schema_clause =
            sectionUIData?.sql_data?.filter_schema_clause;
        }

        const encryptRequestData = EncryptUtils.encryptedData(data);

        const res: any = await getAllUsers(
          {
            tk: encryptRequestData
          },
          applicationName
        );
        if (columns && columns.length) {
          formatResponseDataFields(columns, res);
        }
        setLoader(false);
        setSortedRowsData(res?.data?.rows, sortModel);
        setRowCount(res?.data?.count?.[0]?.count);
        if (setRowsCountData && typeof setRowsCountData === 'function') {
          setRowsCountData(res?.data?.count?.[0]?.count);
        }
        if (setRowsPAData && typeof setRowsPAData === 'function') {
          setRowsPAData(res?.data);
        }
      } else if (module === FormConstants.MODULE.UAM) {
        setLoader(true);

        const data: any = {
          limit: limit || environment?.defaultRowsLimit,
          offset: offset || 0,
          sort_by: getSortField(sortModel) || '',
          sort: sortModel?.[0]?.sort || '',
          org_id: '',
          sql_data: {
            is_audit: true,
            audit_event_description: FormConstants.COMMON.VIEWED_USERS
          }
        };

        if (filterModel?.items?.length > 0) {
          data.filterModel = filterModel?.items;
          data.logicOperator = filterModel?.logicOperator;
          data.filter_schema_clause =
            sectionUIData?.sql_data?.filter_schema_clause;
        }

        const encryptRequestData = EncryptUtils.encryptedData(data);

        const res: any = await getAllUsersSettings(
          {
            tk: encryptRequestData
          },
          applicationName
        );
        if (columns && columns.length) {
          formatResponseDataFields(columns, res);
        }
        setLoader(false);
        setSortedRowsData(res?.data?.rows, sortModel);
        setRowCount(res?.data?.count?.[0]?.count);
        if (setRowsCountData && typeof setRowsCountData === 'function') {
          setRowsCountData(res?.data?.count?.[0]?.count);
        }
        if (setRowsPAData && typeof setRowsPAData === 'function') {
          setRowsPAData(res?.data);
        }
      } else if (props?.rows?.length > 0) {
        setSortedRowsData(props?.rows || rowsData, sortModel);
        setRowCount(props?.rowCount || rowCount);
        if (setRowsCountData && typeof setRowsCountData === 'function') {
          setRowsCountData(props?.rowCount || rowCount);
        }
        setLoader(false);
      }
    } catch (e) {
      setLoader(false);
      const errMessage = getErrorMessage(e);
      enqueueSnackbar(errMessage, SnackBarConfig.getError());
    }
    //     finally { // FOCUS LOGIC BELONGS HERE
    //  previousFilterModelRef.current = filterModel;
    //        if (!loader) { // Only try to focus if not loading
    //            setTimeout(() => {
    //                if (quickFilterInputRef.current) {
    //                    quickFilterInputRef.current.focus();
    //                    quickFilterInputRef.current.setSelectionRange(
    //                        quickFilterInputRef.current.value.length,
    //                        quickFilterInputRef.current.value.length
    //                    );
    //                    console.log('Focus applied after delay!');
    //                } else {
    //                    console.log('Ref still null after delay, could not apply focus.');
    //                }
    //            }, 50); //delay like 50ms
    //        }
    //     }
  };

  React.useEffect(() => {
    setupdatedcolumn(columns);
  }, [
    columns,
    sectionUIData?.sql_data?.sql,
    isReportsButtonLoader,
    isEnabled,
    ParentLegacyValue,
    sectionUIData,
    growthChartType,
    location?.search,
    sub_module,
    usersync
  ]);
  React.useEffect(() => {
    setupdatedcolumn(columns);
    if (apiRef.current?.setFilterModel) {
      apiRef.current.setFilterModel({
        items: [],
        logicOperator: 'and' as GridLogicOperator,
        quickFilterValues: []
      });
    }
    setGridFilters(undefined);
    const timerId = setTimeout(() => {
      // Avoid calling init() when sub_module is 'dicom' or 'documents' or 'flowsheets' or 'vital'
      if (
        sub_module === FormConstants.SUB_MODULE.DICOM ||
        sub_module === FormConstants.SUB_MODULE.DOCUMENTS ||
        sub_module === FormConstants.SUB_MODULE.FLOW_SHEETS ||
        (sub_module === FormConstants.SUB_MODULE.VITALS && !growthChartType)
      ) {
        return;
      }
      if (usersync === true) {
        setLoader(true);
      } else {
        if (getPatientAccoutningData && sub_module === 'accounts') {
          const values = localStorage.getItem('PATabledata');
          if (values) {
            const data = JSON.parse(values);
            const PAData = JSON.parse(getPatientAccoutningData);

            init(
              false,
              data.pageSize,
              data.offset * (data.pageSize || 0),
              data.sortModel,
              data.gridFilters,
              data?.yearTrue
            );
            setGridPage(data.offset);
            setGridSortModel(data.sortModel);
            setGridOffset(data.offset * (data.pageSize || 0));
            setGridFilters(data.gridFilters);
            gridPageSize.current = data.pageSize;
          }
        } else {
          setupdatedcolumn(columns);
          init();
          setGridFilters();
          setGridSortModel(undefined);
        }
      }
    }, 2);
    return () => clearTimeout(timerId);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    columns,
    sectionUIData?.sql_data?.sql,
    isReportsButtonLoader,
    isEnabled,
    ParentLegacyValue,
    sectionUIData,
    growthChartType,
    location?.search,
    sub_module,
    usersync
  ]);
  React.useEffect(() => {
    // Avoid calling init() when sub_module is 'dicom' or 'documents' or 'flowsheets' or 'vital'
    if (props?.tableRefresh) {
      init();
      props?.setTableRefresh && props?.setTableRefresh(false);
    }
  }, [props?.tableRefresh]);
  const initFilterData = () => {
    if (
      module === FormConstants.MODULE.CLINICAL &&
      sub_module === FormConstants.SUB_MODULE.REPORTS
    ) {
      setSelectionModel([]);
    } else {
      setSelectionModel(selectedFiltersList);
    }
  };

  React.useEffect(() => {
    initFilterData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [SelectedCheckBoxState]);

  const handleOnPageChange = (newPage: number): void => {
    if (setopening) {
      setopening(false);
    }
    init(
      true,
      gridPageSize?.current,
      newPage * (gridPageSize?.current || 0),
      gridSortModel,
      gridFilters
    );
    setGridPage(newPage);
    setGridOffset(newPage * (gridPageSize?.current || 0));
  };

  const handleOnPageSizeChange = (newPageSize: number): void => {
    gridPageSize.current = newPageSize;
    setGridOffset(0);
    setGridPage(0);
    init(true, newPageSize, 0, gridSortModel, gridFilters);
  };

  const handleOnSortModelChange = (newSortModel: any): void => {
    if (
      props.onSortModelChange &&
      typeof props.onSortModelChange === 'function'
    ) {
      props.onSortModelChange(newSortModel);
    }
    setGridSortModel(newSortModel);
    if (isClientSortingEnabled) {
      setRowsData((currentRows: any[]) =>
        sortRowsByModel(currentRows, newSortModel, updatecolumn)
      );
    }
    init(true, gridPageSize.current, gridOffset, newSortModel, gridFilters);
  };

  const onFilterChange = React.useCallback(
    (type: any) => (filterModel: GridFilterModel) => {
      if (!updatecolumn || updatecolumn.length === 0) return;
      const normalizedFilterModel = sanitizeGridFilterModel(
        filterModel,
        type || updatecolumn
      );
      const prev = previousFilterModelRef.current;
      const filterChanged =
        JSON.stringify(previousFilterModelRef.current) !==
        JSON.stringify(normalizedFilterModel);
      if (!filterChanged) return;
      previousFilterModelRef.current = normalizedFilterModel;
      const hasValidValue = normalizedFilterModel?.items?.some((item: any) => {
        if (!item) return false;

        const val = item.value;
        const operator = item.operator;
        if (FILTER_OPERATORS_WITHOUT_VALUE.includes(operator)) return true;

        if (val === undefined || val === null) return false;

        if (Array.isArray(val)) {
          return val.some(
            v => v !== undefined && v !== null && v.toString().trim() !== ''
          );
        }

        return val.toString().trim() !== '';
      });

      const hasQuickFilter =
        normalizedFilterModel?.quickFilterValues?.some(
          (v: any) => v && v.toString().trim() !== ''
        ) ?? false;
      // console.log('filterModel.quickFilterValues---',filterModel.quickFilterValues);
      // CLEAR quick search (clicking X)
      if (
        Array.isArray(normalizedFilterModel.quickFilterValues) &&
        normalizedFilterModel.quickFilterValues.length === 0 &&
        Array.isArray(prev?.quickFilterValues) &&
        prev.quickFilterValues.length > 0
      ) {
        setGridFilters({
          items: [],
          logicOperator: 'and',
          quickFilterValues: []
        });
        setShouldFocusQuickFilter(false); // Reset focus signal
        init(
          true,
          gridPageSize.current,
          gridOffset,
          gridSortModel,
          {items: [], logicOperator: 'and'},
          false
        );

        return;
      }
      // ---------search box------------------
      if (
        normalizedFilterModel.quickFilterValues &&
        normalizedFilterModel.quickFilterValues.length &&
        normalizedFilterModel.quickFilterValues[0].trim() !== ''
      ) {
        const quickValue = normalizedFilterModel.quickFilterValues[0];

        // Build global OR filter (without touching filterModel)
        const searchableColumns = updatecolumn.filter(
          (col: any) =>
            ['string', 'text', 'varchar', 'singleSelect'].includes(col.column_type) &&
            !col.skip_filter &&
            col.filterable === true
        );

        const globalFilter: GridFilterModel = {
          items: searchableColumns.map((col: any) => ({
            field: col.field,
            operator: 'contains',
            value: quickValue
          })),
          logicOperator: 'or' as any
        };
        setGridFilters({
          ...normalizedFilterModel,
          quickFilterValues: normalizedFilterModel.quickFilterValues
        });

        // DO NOT CALL setGridFilters()
        // DO NOT MUTATE filterModel

        init(
          true,
          gridPageSize.current,
          gridOffset,
          gridSortModel,
          globalFilter,
          false
        );
        setShouldFocusQuickFilter(true);
        return; // always return to avoid continued filter chain
      }
      // ---------------------------
      const hasActiveFilter = hasValidValue || hasQuickFilter;

      // All filters removed → reload full data once
      // const prevHadFilters =
      //   prev?.items?.some(
      //     (item: any) =>
      //       item?.value !== undefined &&
      //       item?.value !== null &&
      //       item?.value?.toString().trim() !== ''
      //   ) || false;
      const prevHadFilters =
        prev?.items?.some((item: any) => {
          if (!item) return false;
          const operator = item.operator;
          if (FILTER_OPERATORS_WITHOUT_VALUE.includes(operator)) return true;
          return (
            item?.value !== undefined &&
            item?.value !== null &&
            item?.value?.toString().trim() !== ''
          );
        }) || false;
      if (!hasActiveFilter && prevHadFilters) {
        setGridFilters(normalizedFilterModel);
        setYearTrue(false);
        setShouldFocusQuickFilter(false); // Reset focus signal
        init(
          true,
          gridPageSize.current,
          gridOffset,
          gridSortModel,
          {items: [], logicOperator: 'and'},
          false
        );
        return;
      }
      if (!hasActiveFilter) {
        setGridFilters(normalizedFilterModel);
        setShouldFocusQuickFilter(false); // Reset focus signal
        return;
      }

      setGridFilters(normalizedFilterModel);
      const firstItem = normalizedFilterModel?.items?.[0] as any;
      let isYearValid = false;
      let fullYear = '';
      const operator = firstItem?.operator;
      if (
        firstItem?.column_type === 'date' ||
        firstItem?.column_type === 'date-time'
      ) {
        if (FILTER_OPERATORS_WITHOUT_VALUE.includes(operator)) {
          setYearTrue(false);

          init(
            true,
            gridPageSize.current,
            gridOffset,
            gridSortModel,
            normalizedFilterModel,
            false
          );
          return;
        }

        let year = new Date();

        const value = firstItem?.value;

        if (Array.isArray(value) && value.length === 2) {
          const [start, end] = value.map(v => new Date(v));
          const areDatesValid =
            start instanceof Date &&
            !isNaN(start.getTime()) &&
            end instanceof Date &&
            !isNaN(end.getTime());
          if (areDatesValid) {
            isYearValid = true;
            year = start; // Or set year based on your logic
          }
        } else if (typeof value === 'string' || value instanceof Date) {
          const parsedDate = new Date(value);
          if (parsedDate instanceof Date && !isNaN(parsedDate.getTime())) {
            isYearValid = true;
            year = parsedDate;
          }
        }

        setYearTrue(isYearValid);

        fullYear = isYearValid ? year.getFullYear().toString() : '';

        if (isYearValid && fullYear.length === 4) {
          init(
            true,
            gridPageSize.current,
            gridOffset,
            gridSortModel,
            normalizedFilterModel,
            isYearValid
          );
        }
      } else {
        setYearTrue(false); // Explicitly reset for non-date fields
        setShouldFocusQuickFilter(false); // Default to false if not a quick filter
        // if (filterModel?.quickFilterValues?.length) {
        init(
          true,
          gridPageSize.current,
          gridOffset,
          gridSortModel,
          normalizedFilterModel,
          false
        );
        // }
      }

      // setGridFilters(filterModel);
      if (
        props.onGridFiltersChange &&
        typeof props.onGridFiltersChange === 'function'
      ) {
        props.onGridFiltersChange(normalizedFilterModel);
      }
    },
    [
      gridPageSize,
      gridOffset,
      gridSortModel,
      updatecolumn,
      props.onGridFiltersChange,
      ParentLegacyValue
    ]
  );
  React.useEffect(() => {
    if (shouldFocusQuickFilter) {
      // Only attempt to focus if signaled AND not currently loading
      const timer = setTimeout(() => {
        if (quickFilterInputRef.current) {
          quickFilterInputRef.current.focus();
          quickFilterInputRef.current.setSelectionRange(
            quickFilterInputRef.current.value.length,
            quickFilterInputRef.current.value.length
          );
          // console.log('Focus applied after delay!');
        } else {
          // console.log('Ref still null after delay, could not apply focus.');
        }
      }, 10); // A small delay can help ensure the DOM is ready
      // Reset the signal so it doesn't try to focus again unnecessarily
      // setShouldFocusQuickFilter(false);
      return () => clearTimeout(timer); // Cleanup timeout
    }
  });
  // eslint-disable-next-line react-hooks/rules-of-hooks

  // FIX: Sync columns immediately when tab switches to prevent old headers flashing
  // React.useEffect(() => {
  //   // Immediately adopt the new tab's columns so headers render correctly from the start
  //   setupdatedcolumn(columns);
  // console.log("enretes8")
  //   // Clear stale row data and reset grid state
  //   setRowsData([]);
  //   setRowCount(0);
  //   setGridPage(0);
  //   setGridSortModel(undefined);
  //   // setLoader(true);

  //   // Reset filter UI via Grid API
  //   if (apiRef.current?.setFilterModel) {
  //     apiRef.current.setFilterModel({
  //       items: [],
  //       logicOperator: 'and' as GridLogicOperator,
  //       quickFilterValues: [],
  //     });
  //   }

  //   // Reset internal filter state
  //   setGridFilters({
  //     items: [],
  //     logicOperator: 'and',
  //     quickFilterValues: []
  //   });

  //   previousFilterModelRef.current = null;

  // }, [sub_module, sectionUIData?.name]);
  // ⚠️ Do NOT add `columns` to deps — causes infinite loop
  useEffect(() => {
    if (props.refreshFilter) {
      apiRef.current?.setFilterModel({
        items: [],
        logicOperator: 'and' as GridLogicOperator,
        quickFilterValues: [],
        quickFilterLogicOperator: 'and' as GridLogicOperator
      });
      props.setRefreshFilter(false);
    }
  }, [props.refreshFilter]);

  const handleCheckBox = (params: any): any => {
    if (handleDisableCheckBox) {
      return GetDisableCheckBox(params);
    } else if (
      props.isRowSelectable &&
      typeof props.isRowSelectable === 'function'
    ) {
      return props.isRowSelectable(params);
    } else {
      return true;
    }
  };

  const initialRowGroupingState = useKeepGroupedColumnsHidden({
    apiRef,
    initialState: {
      columns: {
        // Hide the column used for leaves
        columnVisibilityModel: hideColumns
      },
      rowGrouping: {
        model: rowGroupingModel
      },
      aggregation: {
        model: aggregationGroupingModel
      }
    }
  });

  if (
    sub_module === FormConstants.SCREENS.FLOWSHEETS ||
    sub_module === FormConstants.SCREENS.VITAL
  ) {
    updatecolumn.forEach((column: any) => {
      if (
        column.field === FormConstants.CLUMN_NAME.VITAL_NAME ||
        column.field === FormConstants.CLUMN_NAME.FLOWSHEET_TYPE ||
        column.field === FormConstants.CLUMN_NAME.PARAMETER_NAME
      ) {
        column.filterable = true;
        column.sortable = true;
      } else {
        column.filterable = false;
        column.sortable = false;
      }
    });
  }

  const defaultPaginationModelChange = (model: any) => {
    model.pageSize === gridPageSize?.current
      ? handleOnPageChange(model.page)
      : handleOnPageSizeChange(model.pageSize);
  };

  const logDataGridResults = (dataObj: any) => {
    const rowsIds: any = [];

    const acceptedList = ['ID', 'PatientID', 'LegacyMRN', 'OrderID'];
    let uniqueKey = '';

    dataObj?.forEach((item: any) => {
      if (typeof item === 'object' && item !== null) {
        for (const acceptedKey of acceptedList) {
          if (acceptedKey in item && item[acceptedKey]) {
            if (!uniqueKey?.length) {
              uniqueKey = acceptedKey;
            }
            rowsIds.push(item[uniqueKey]);
            break; // Stop iterating after finding the first accepted key
          }
        }
      }
    });

    let eventDescription = params.module_name
      ? params.module_name + ' -> '
      : '';

    if (params.submodule_name) {
      eventDescription += `${params.submodule_name}`;
    }

    if (sectionUIData?.sql_data?.audit_event_description) {
      eventDescription += ` -> ${sectionUIData?.sql_data?.audit_event_description}`;
    } else if (sectionUIData?.name) {
      eventDescription += ` -> ${sectionUIData?.name}`;
    }

    const data = {
      module: params.module_name,
      sub_module: params.submodule_name,
      sub_module_identifier: JSON.stringify({
        uniqueKey,
        rowsIDs: rowsIds.join(', ')
      }),
      procedure_type,
      application_name: applicationName,
      isBH_selected: !isBHReason?.length && isBH == false ? true : isBH,
      isBH_reason: isBHReason,
      event_description: `Data Grid Results : ${eventDescription}`,
      audit_identifier: AuthUtils.getAuditIdentifier(),
      audit_identifier_type: AuthUtils.getAuditIdentifierType(),
      audit_legacy_app: AuthUtils.getAuditLegacyApp()
    };
    createAuditLog(props.module, data);
  };

  const logExcelData = (dataObj: any) => {
    if (dataObj?.sql_data) {
      delete dataObj.sql_data;
    }

    const keyValueString = Object.entries(dataObj)
      .map(([key, value]) => {
        if (value) return `${key}: ${JSON.stringify(value)}`;
        return null;
      })
      .filter(Boolean)
      .join(', ');

    let eventDescription = props.module ? props.module + ' -> ' : '';

    if (sectionUIData?.sql_data?.audit_event_description) {
      eventDescription += `${sectionUIData?.sql_data?.audit_event_description}`;
    } else if (sectionUIData?.name) {
      eventDescription += `${sectionUIData?.name}`;
    }

    const data = {
      module: props?.module,
      sub_module: params.submodule_name,
      sub_module_identifier: keyValueString,
      procedure_type,
      application_name: applicationName,
      isBH_selected: !isBHReason?.length && isBH == false ? true : isBH,
      isBH_reason: isBHReason,
      event_description: dataObj?.exportedAs + ' : ' + eventDescription,
      audit_identifier: AuthUtils.getAuditIdentifier(),
      audit_identifier_type: AuthUtils.getAuditIdentifierType(),
      audit_legacy_app: AuthUtils.getAuditLegacyApp()
    };
    createAuditLog(props.module, data);
  };

  const handleExport = async () => {
    try {
      setExportExcelLoading(true);
      const values: any = {
        sql_data: sectionUIData?.sql_data,
        user_id: props?.recordId,
        record_id: props?.recordId,
        legacyApp: props?.legacyApp,
        email: props?.searchFormFieldsData?.email,
        start_date: props?.searchFormFieldsData?.start_date,
        end_date: props?.searchFormFieldsData?.end_date,
        isBh: props?.searchFormFieldsData?.isBh,
        legacy_app: normalizeValue(props?.searchFormFieldsData?.legacy_app),
        company: normalizeValue(props?.searchFormFieldsData?.company), //for finance reports
        department: normalizeValue(props?.searchFormFieldsData?.department), //for finance reports
        year: normalizeValue(props?.searchFormFieldsData?.year), //for finance reports
        status: normalizeValue(props?.searchFormFieldsData?.status), //for finance reports
        system: normalizeValue(props?.searchFormFieldsData?.system), //for finance reports
        account: normalizeValue(props?.searchFormFieldsData?.account), //for finance reports
        period: normalizeValue(props?.searchFormFieldsData?.period), //for finance reports
        legacy_dob: props?.searchFormFieldsData?.legacy_dob,
        legacy_mrn: props?.searchFormFieldsData?.legacy_mrn,
        patient_first_name: props?.searchFormFieldsData?.patient_first_name,
        patient_last_name: props?.searchFormFieldsData?.patient_last_name,
        corporation:
          props?.searchFormFieldsData?.corporation ??
          sectionUIData?.export_name,
        fiscal_year: props?.searchFormFieldsData?.fiscal_year,
        from_period: props?.searchFormFieldsData?.from_period,
        source_system: props?.searchFormFieldsData?.source_system,
        to_period: props?.searchFormFieldsData?.to_period,
        moduleSelected:
          props?.searchFormFieldsData?.sql_data?.module_name_selected,
        exportExcel: sectionUIData.is_export_data_needed,
        bannerData: bannerDetails,
        submodule: props?.sub_module,
        tabsSubName: props?.sectionUIData?.name,
        module: props?.module,
        sort_by: sectionUIData?.sql_data?.schema_clause
          ? `${sectionUIData?.sql_data?.schema_clause}.${gridSortModel?.[0]?.field}`
          : getSortField(gridSortModel),
        sort: gridSortModel?.[0]?.sort
      };
      if (gridFilters?.items?.length > 0) {
        // const filteredTypes =
        // filterModel && filterModel.items
        //   ? getColumnTypes(updatecolumn, filterModel)
        //   : [];
        values.filtertype = yearTrue;
        values.filterModel = gridFilters?.items;
        values.logicOperator = gridFilters?.logicOperator;
        values.filter_schema_clause =
          sectionUIData?.sql_data?.filter_schema_clause;
      }
      const encryptRequestData = EncryptUtils.encryptedData(values);
      let response;
      try {
        response = await getReportsFileExportData({
          tk: encryptRequestData
        });
        logExcelData({...values, exportedAs: 'Exported as Excel'});
      } catch (error) {
        throw new Error('Failed to fetch Excel file.');
      }
      const fileDownloadData = response.data;
      const headers = response.headers;
      let filename = 'exported_data.xlsx'; // Default filename if none is provided

      const contentDisposition = headers['content-disposition'];

      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(
          /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
        );
        if (filenameMatch != null && filenameMatch[1]) {
          filename = filenameMatch[1].replace(/['"]/g, ''); // Remove quotes around filename
        }
      }

      const url = URL.createObjectURL(fileDownloadData);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();

      link.parentNode?.removeChild(link);
      URL.revokeObjectURL(url);
      setExportExcelLoading(false);
    } catch (error) {
      setExportExcelLoading(false);
      console.error('Error exporting Excel:', error);
    }
  };

  const normalizeValue = (val: any) => (val === '' ? undefined : val);
  const handleCSV = async (): Promise<void> => {
    try {
      setExportCSVLoading(true);
      const values: any = {
        sql_data: sectionUIData?.sql_data,
        user_id: props?.recordId,
        record_id: props?.recordId,
        legacyApp: props?.legacyApp,
        email: props?.searchFormFieldsData?.email,
        start_date: props?.searchFormFieldsData?.start_date,
        end_date: props?.searchFormFieldsData?.end_date,
        isBh: props?.searchFormFieldsData?.isBh,
        legacy_app: normalizeValue(props?.searchFormFieldsData?.legacy_app),
        company: normalizeValue(props?.searchFormFieldsData?.company), //for finance reports
        department: normalizeValue(props?.searchFormFieldsData?.department), //for finance reports
        year: normalizeValue(props?.searchFormFieldsData?.year), //for finance reports
        status: normalizeValue(props?.searchFormFieldsData?.status), //for finance reports
        system: normalizeValue(props?.searchFormFieldsData?.system), //for finance reports
        account: normalizeValue(props?.searchFormFieldsData?.account), //for finance reports
        period: normalizeValue(props?.searchFormFieldsData?.period), //for finance reports
        legacy_dob: props?.searchFormFieldsData?.legacy_dob,
        legacy_mrn: props?.searchFormFieldsData?.legacy_mrn,
        patient_first_name: props?.searchFormFieldsData?.patient_first_name,
        patient_last_name: props?.searchFormFieldsData?.patient_last_name,
        corporation:
          props?.searchFormFieldsData?.corporation ??
          sectionUIData?.export_name,
        fiscal_year: props?.searchFormFieldsData?.fiscal_year,
        from_period: props?.searchFormFieldsData?.from_period,
        source_system: props?.searchFormFieldsData?.source_system,
        to_period: props?.searchFormFieldsData?.to_period,
        tabsSubName: props?.sectionUIData?.name,
        moduleSelected:
          props?.searchFormFieldsData?.sql_data?.module_name_selected,
        exportCSV: sectionUIData.is_export_data_needed,
        bannerData: bannerDetails,
        submodule: props?.sub_module,
        module: props?.module,
        sort_by: sectionUIData?.sql_data?.schema_clause
          ? `${sectionUIData?.sql_data?.schema_clause}.${gridSortModel?.[0]?.field}`
          : getSortField(gridSortModel),
        sort: gridSortModel?.[0]?.sort
      };
      if (gridFilters?.items?.length > 0) {
        // const filteredTypes =
        // filterModel && filterModel.items
        //   ? getColumnTypes(updatecolumn, filterModel)
        //   : [];
        values.filtertype = yearTrue;
        values.filterModel = gridFilters?.items;
        values.logicOperator = gridFilters?.logicOperator;
        values.filter_schema_clause =
          sectionUIData?.sql_data?.filter_schema_clause;
      }
      const encryptRequestData = EncryptUtils.encryptedData(values);
      let response;
      try {
        response = await getReportsFileExportData({
          tk: encryptRequestData
        });
        logExcelData({...values, exportedAs: 'Exported as CSV'});
      } catch (error) {
        throw new Error('Failed to fetch CSV file.');
      }
      const fileDownloadData = response.data;
      const headers = response.headers;
      let filename = 'exported_data.xlsx'; // Default filename if none is provided

      const contentDisposition = headers['content-disposition'];

      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(
          /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
        );
        if (filenameMatch != null && filenameMatch[1]) {
          filename = filenameMatch[1].replace(/['"]/g, ''); // Remove quotes around filename
        }
      }

      const url = URL.createObjectURL(fileDownloadData);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();

      // Cleanup
      link.parentNode?.removeChild(link);
      URL.revokeObjectURL(url);
      setExportCSVLoading(false);
    } catch (error) {
      setExportCSVLoading(false);
      console.error('Error exporting Excel:', error);
    }
  };

  const handlePDF = async (): Promise<void> => {
    try {
      setExportPDFLoading(true);
      const values: any = {
        sql_data: sectionUIData?.sql_data,
        user_id: props?.recordId,
        record_id: props?.recordId,
        legacyApp: props?.legacyApp,
        email: props?.searchFormFieldsData?.email,
        start_date: props?.searchFormFieldsData?.start_date,
        end_date: props?.searchFormFieldsData?.end_date,
        isBh: props?.searchFormFieldsData?.isBh,
        legacy_app: normalizeValue(props?.searchFormFieldsData?.legacy_app),
        company: normalizeValue(props?.searchFormFieldsData?.company), //for finance reports
        department: normalizeValue(props?.searchFormFieldsData?.department), //for finance reports
        year: normalizeValue(props?.searchFormFieldsData?.year), //for finance reports
        status: normalizeValue(props?.searchFormFieldsData?.status), //for finance reports
        system: normalizeValue(props?.searchFormFieldsData?.system), //for finance reports
        account: normalizeValue(props?.searchFormFieldsData?.account), //for finance reports
        period: normalizeValue(props?.searchFormFieldsData?.period), //for finance reports
        legacy_dob: props?.searchFormFieldsData?.legacy_dob,
        legacy_mrn: props?.searchFormFieldsData?.legacy_mrn,
        patient_first_name: props?.searchFormFieldsData?.patient_first_name,
        patient_last_name: props?.searchFormFieldsData?.patient_last_name,
        corporation:
          props?.searchFormFieldsData?.corporation ??
          sectionUIData?.export_name,
        fiscal_year: props?.searchFormFieldsData?.fiscal_year,
        from_period: props?.searchFormFieldsData?.from_period,
        source_system: props?.searchFormFieldsData?.source_system,
        to_period: props?.searchFormFieldsData?.to_period,
        moduleSelected:
          props?.searchFormFieldsData?.sql_data?.module_name_selected,
        exportPDF: sectionUIData.is_export_data_needed,
        bannerData: bannerDetails,
        submodule: props?.sub_module,
        module: props?.module,
        tabsSubName: props?.sectionUIData?.name,
        sort_by: sectionUIData?.sql_data?.schema_clause
          ? `${sectionUIData?.sql_data?.schema_clause}.${gridSortModel?.[0]?.field}`
          : getSortField(gridSortModel),
        sort: gridSortModel?.[0]?.sort
      };

      if (gridFilters?.items?.length > 0) {
        // const filteredTypes =
        // filterModel && filterModel.items
        //   ? getColumnTypes(updatecolumn, filterModel)
        //   : [];
        values.filtertype = yearTrue;
        values.filterModel = gridFilters?.items;
        values.logicOperator = gridFilters?.logicOperator;
        values.filter_schema_clause =
          sectionUIData?.sql_data?.filter_schema_clause;
      }
      const encryptRequestData = EncryptUtils.encryptedData(values);
      let response;
      try {
        response = await getReportsFileExportData({
          tk: encryptRequestData
        });
        logExcelData({...values, exportedAs: 'Exported as PDF'});
      } catch (error) {
        throw new Error('Failed to fetch PDF file.');
      }
      const fileDownloadData = response.data;
      const headers = response.headers;
      let filename = 'exported_data.xlsx'; // Default filename if none is provided

      const contentDisposition = headers['content-disposition'];

      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(
          /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
        );
        if (filenameMatch != null && filenameMatch[1]) {
          filename = filenameMatch[1].replace(/['"]/g, ''); // Remove quotes around filename
        }
      }

      const url = URL.createObjectURL(fileDownloadData);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();

      // Cleanup
      link.parentNode?.removeChild(link);
      URL.revokeObjectURL(url);
      setExportPDFLoading(false);
    } catch (error) {
      setExportPDFLoading(false);
      console.error('Error exporting Excel:', error);
    }
  };
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const CustomToolbar = () => (
    <GridToolbarContainer
      sx={{display: 'flex', alignItems: 'center', position: 'relative'}}>
      {enableGridSearch && (
        <GridToolbarQuickFilter
          inputRef={quickFilterInputRef}
          className="quick-search-filter"
          sx={{
            right: 15,
            width: '200px !important',
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: '#0000003b',
              borderWidth: '1.8px'
            },
            '& svg': {
              color: theme.palette.primary.lighter
            },
            '& .MuiInputBase-inputAdornedEnd': {
              padding: '7.5px 7px !important'
            }
          }}
        />
      )}
      <Box sx={{flexGrow: 1}} />
      {/* <GridToolbarFilterButton />
      <GridToolbarColumnsButton />
      <GridToolbarDensitySelector /> */}
      {/* <div ref={anchorRef}>
        <Fab
          onClick={() => setTableSizeMenu(true)}
          key={'table-length'}
          variant="outlinedExtended"
          size="small">
          <Iconify icon="ic:baseline-view-day" width={24} />
          Grid Height
        </Fab>
      </div>
      {tableSizeMenu && anchorRef?.current ? (
        <Menu
          sx={{position: 'absolute'}}
          id="demo-positioned-menu"
          anchorEl={anchorRef.current}
          open={tableSizeMenu}
          onClose={() => setTableSizeMenu(false)}
          // getContentAnchorEl={null}
          anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
          transformOrigin={{vertical: 'top', horizontal: 'center'}}>
          <MenuItem
            selected={gridHeight == '50vh'}
            onClick={() => handleGridMenuClose('50vh')}>
            small
          </MenuItem>
          <MenuItem
            selected={gridHeight == '70vh'}
            onClick={() => handleGridMenuClose('70vh')}>
            medium
          </MenuItem>
          <MenuItem
            selected={gridHeight == '100vh'}
            onClick={() => handleGridMenuClose('100vh')}>
            large
          </MenuItem>
        </Menu>
      ) : null} */}
      {sectionUIData.is_export_data_needed ? (
        <>
          <Tooltip title="Download as Excel Spreadsheet" arrow>
            <LoadingButton
              onClick={() => {
                if (props?.module === 'custom_reports') {
                  // handleExport();
                  if (
                    props?.rowsCountData >
                    (environment?.CUSTOM_REPORTS_MAX_ROWS_FOR_EXPORT ?? 5000)
                  ) {
                    setShowDialogOpen(true);
                    setActiveAction('excel');
                  } else {
                    handleExport();
                  }
                } else {
                  handleExport();
                }
              }}
              variant="contained"
              color="primary"
              loading={excelloading}>
              Export to Excel
            </LoadingButton>
          </Tooltip>
          <Tooltip title="Download as CSV" arrow>
            <LoadingButton
              onClick={() => {
                if (props?.module === 'custom_reports') {
                  // handleExport();
                  if (
                    props?.rowsCountData >
                    (environment?.CUSTOM_REPORTS_MAX_ROWS_FOR_EXPORT ?? 5000)
                  ) {
                    setShowDialogOpen(true);
                    setActiveAction('csv');
                  } else {
                    handleCSV();
                  }
                } else {
                  handleCSV();
                }
              }}
              variant="contained"
              color="primary"
              loading={csvloading}>
              Export to CSV
            </LoadingButton>
          </Tooltip>
          <Tooltip title="Download as Pdf" arrow>
            <LoadingButton
              onClick={() => {
                if (props?.module === 'custom_reports') {
                  // handleExport();
                  if (
                    props?.rowsCountData >
                    (environment?.CUSTOM_REPORTS_MAX_ROWS_FOR_EXPORT ?? 5000)
                  ) {
                    setShowDialogOpen(true);
                    setActiveAction('pdf');
                  } else {
                    handlePDF();
                  }
                } else {
                  handlePDF();
                }
              }}
              variant="contained"
              color="primary"
              loading={pdfloading}>
              Export to PDF
            </LoadingButton>
          </Tooltip>
        </>
      ) : null}
    </GridToolbarContainer>
  );

  useEffect(() => {
    if (rowsData?.length) {
      logDataGridResults(rowsData);
    }
  }, [rowsData]);

  const getMinHeight = () => {
    if (props.minHeight) {
      return props.minHeight;
    }
    return loader || props?.loading
      ? '90px !important'
      : props?.hideFooter === false
        ? '0vh'
        : '200px !important';
  };

  const handleDoubleClick = (params: any, apiRef: any) => {
    const colId = params.field;
    const rows = apiRef.current.getRowModels();
    let maxWidth = 100; // Minimum width
    rows.forEach((row: any) => {
      const value = row[colId]?.toString() || '';
      const length = value.length * 7; // Approximate character width
      maxWidth = Math.max(maxWidth, length);
    });
    apiRef.current.setColumnWidth(colId, maxWidth);
  };

  return (
    <div
      className="data-grid-wrapper"
      style={{
        marginTop: '1rem',
        marginBottom: '1rem',
        maxHeight: 'auto'
      }}>
      {sectionUIData?.isLabel && (
        <Typography
          color="primary"
          sx={{
            fontWeight: 'bold',
            marginY: '0.5rem',
            color: `${theme.palette.common.black}`,
            fontSize: '1rem !important',
            alignItems: 'flex-start'
          }}>
          {sectionUIData?.label}
        </Typography>
      )}

      <HighlighterWrapper keywords={[search_context]}>
        <StripedDataGrid
          sx={{
            backgroundColor: `${APP.PALETTE.COMMON.WHITE}`,
            '& .MuiTablePagination-displayedRows': {
              display: 'none'
            },
            '& .MuiPagination-ul': {
              flexWrap: 'nowrap'
            },
            '& .MuiDataGrid-row': {
              border: '1px solid lightgray',
              borderTopWidth: '0px',
              width: 'calc(100% - 2px)'
            },
            '& .MuiDataGrid-columnHeaders': {
              border: '1px solid lightgray',
              backgroundColor: `${theme.palette.grey[300]}`,
              borderBottomColor: `${theme.palette.primary.lighter}`,
              borderBottomWidth: '1px'
            },
            '& .MuiDataGrid-columnHeader--moving': {
              backgroundColor: `${APP.PALETTE.DATA_GRID.HEADER}`
            },
            '& .AbnormalFlagText': {
              color: `${APP.PALETTE.ABNORMAL_FLAG.TEXT}`,
              fontWeight: 'bold !important'
            },
            '& .css-87hgir-MuiTypography-root': {
              fontWeight: 'unset'
            },
            '& .css-11d09j8-MuiButtonBase-root-MuiCheckbox-root.Mui-checked': {
              color: props?.checkboxColor || `${theme.palette.primary.lighter}`
            },
            '& .MuiDataGrid-virtualScroller': {
              minHeight: getMinHeight(),
              maxHeight: props?.gridHeight ?? '50vh',
              overflowY: 'hidden !important',
              scrollBehavior: 'smooth',
              zIndex: 9,
              // position: 'relative',
              overflow:
                ['vital', 'flowsheets'].includes(sectionUIData.name) ||
                props.displayHorizontalScroll
                  ? 'auto !important'
                  : 'visible !important'
            },
            '& .MuiDataGrid-footerContainer': {
              marginBottom: '1rem'
            },
            '& .MuiDataGrid-detailPanel': {
              border: '1px solid lightgray'
            },
            '& .MuiDataGrid-pinnedRowsRenderZone': {
              fontWeight: 'bolder'
            },
            px: 3,
            ...sx
          }}
          {...rest}
          loading={loader || props?.loading}
          className={className}
          getRowClassName={(params: any) => {
            if (
              module === FormConstants.MODULE.LIS &&
              params?.row?.AbnormalFlag
            ) {
              return `pre-whitespace ${FormConstants.ABNORMAL_FLAG.TEXT}`.trim();
            }
            return rowStyles(params);
          }}
          columnHeaderHeight={props.columnHeaderHeight ?? 42}
          rows={rowsData}
          pinnedRows={{
            bottom: pinnedRows?.length ? pinnedRows : pinnedRowsData || []
          }}
          rowHeight={rowHeight}
          onRowClick={onRowClick}
          showCellVerticalBorder={true}
          rowThreshold={rowThreshold}
          showColumnVerticalBorder
          columns={
            sub_module === FormConstants.SCREENS.FLOWSHEETS
              ? newcolumns.filter((column: any) => column.field !== 'ID')
              : newcolumns
          }
          experimentalFeatures={
            rowGroupingData ? {aggregation: true} : experimentalFeatures
          }
          columnGroupingModel={columnGroupingModel}
          getDetailPanelContent={getDetailPanelContent}
          detailPanelExpandedRowIds={
            props?.expandedRowIds?.length ?? 0 > 0
              ? props.expandedRowIds
              : props?.expandedRowIds === undefined
                ? undefined
                : []
          }
          getDetailPanelHeight={getDetailPanelHeight}
          paginationModel={{
            page: gridPage,
            pageSize: gridPageSize?.current ?? 100
          }}
          rowCount={rowCount}
          paginationMode={
            sectionUIData?.client_side_pagination ? 'client' : paginationMode
          }
          sortingMode={
            sectionUIData?.client_side_pagination
              ? 'client'
              : rowGroupingData
                ? ''
                : sortingMode
          }
          sortingOrder={sortingOrder}
          pageSizeOptions={rowsPerPageOptions}
          autoHeight={autoHeight !== undefined ? autoHeight : true}
          disableColumnSelector={
            disableColumnSelector ? disableColumnSelector : true
          }
          onColumnHeaderDoubleClick={params =>
            handleDoubleClick(params, apiRef)
          }
          disableRowSelectionOnClick={
            disableRowSelectionOnClick ? disableRowSelectionOnClick : true
          }
          disableRowGrouping={!rowGroupingData}
          apiRef={apiRef}
          initialState={
            rowGroupingData ? initialRowGroupingState : initialStateData
          }
          slotProps={{
            loadingOverlay: {
              sx: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '90px'
              }
            },
            filterPanel: {
              sx: {'& .MuiDataGrid-filterFormValueInput': {width: 'auto'}}
            }
          }}
          slots={{
            ...slots,
            toolbar: CustomToolbar,
            noRowsOverlay:
              loader || props?.loading
                ? () => (
                    <CircularProgressDiv height="150px">
                      <PulseLoader
                        size={10}
                        color={theme.palette.primary.main}
                      />
                    </CircularProgressDiv>
                  )
                : slots?.noRowsOverlay,
            noResultsOverlay:
              loader || props?.loading
                ? () => (
                    <CircularProgressDiv height="150px">
                      <PulseLoader
                        size={10}
                        color={theme.palette.primary.main}
                      />
                    </CircularProgressDiv>
                  )
                : slots?.noResultsOverlay
          }}
          getRowId={getResolvedRowId}
          style={style}
          rowGroupingColumnMode={rowGroupingData ? 'multiple' : undefined}
          groupingColDef={groupingColDef}
          hideFooter={props?.hideFooter}
          pagination={rowCount > 0 ? true : false}
          onPaginationModelChange={
            onPaginationModelChange
              ? onPaginationModelChange()
              : defaultPaginationModelChange
          }
          // onPaginationModelChange={(model: any) =>
          //   model.pageSize === gridPageSize?.current
          //     ? handleOnPageChange(model.page)
          //     : handleOnPageSizeChange(model.pageSize)
          // }
          onSortModelChange={newSortModel =>
            handleOnSortModelChange(newSortModel)
          }
          checkboxSelection={checkboxSelection ? checkboxSelection : false}
          onRowSelectionModelChange={(newSelectionModel: any) => {
            setSelectionModel(newSelectionModel);
            handleOnSelectionModelChange({
              ids: newSelectionModel,
              data: rowsData
            });
          }}
          isRowSelectable={(params: GridRowParams) => {
            return handleCheckBox(params);
          }}
          rowSelectionModel={selectionModel || selectedCheckboxColumns}
          hideFooterSelectedRowCount={checkboxSelection ? false : true}
          keepNonExistentRowsSelected
          onCellClick={onCellClick}
          getAggregationPosition={groupNode =>
            groupNode?.groupingField === aggregationPosition ? 'inline' : null
          }
          disableAggregation={sectionUIData.aggregable}
          isGroupExpandedByDefault={isGroupExpandedByDefault}
          filterMode={
            sectionUIData?.client_side_pagination
              ? 'client'
              : gridFilters?.quickFilterValues && !gridFilters?.items?.length
                ? 'client'
                : 'server'
          }
          filterDebounceMs={environment?.DATA_GRID_FILTER_DEBOUNCE_TIME || 500}
          filterModel={gridFilters}
          sortModel={gridSortModel}
          onFilterModelChange={onFilterChange(updatecolumn)}
          processRowUpdate={props?.processRowUpdate}
        />
      </HighlighterWrapper>
      <Dialog
        open={showDialog}
        onClose={() => {
          setShowDialogOpen(false);
          setActiveAction(null);
        }}>
        <DialogTitle>Export</DialogTitle>

        <DialogContent>
          <Typography sx={{mb: 3}}>
            {`Only the first ${environment.CUSTOM_REPORTS_MAX_ROWS_FOR_EXPORT || 5000} rows will be included in the exported file.`}
          </Typography>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => {
              setShowDialogOpen(false);
              setActiveAction(null);
            }}
            variant="outlined"
            color="inherit">
            Cancel
          </Button>
          <Button
            onClick={() => {
              setShowDialogOpen(false);
              if (activeAction == 'excel') {
                handleExport();
              } else if (activeAction === 'csv') {
                handleCSV();
              }else if (activeAction === 'pdf') {
                handlePDF();
              }
              setActiveAction(null);
            }}
            variant="contained">
            Continue
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default DataGridComponent;

